import { showToast } from './toast.js';

const PREVIEW_URL = '/dashboard/command-center/preview/';
const EXECUTE_URL = '/dashboard/command-center/execute/';
const HISTORY_URL = '/dashboard/command-center/history/';
const SUGGESTIONS_URL = '/dashboard/command-center/suggestions/';
const DATA_CACHE_KEY = 'pointscasa.power_menu.data.v10';
const DATA_CACHE_TTL_MS = 5 * 60 * 1000;
const INPUT_SETTLE_DELAY_MS = 350;
const PRO_BADGE_LABEL = '✨ pro';
const DEFAULT_PLACEHOLDER = 'Type a command...';
const BALANCE_MODE_PLACEHOLDER = 'I have 5000 Infinia 12000 Axis Atlas';
const CONSULTING_URL = 'https://cal.com/team/pointscasa';
const DOCS_BASE_URL = 'https://docs.points.casa';
const HELP_QUERY_RE = /^(?:\?|help(?:\s+.*)?|show\s+help(?:\s+.*)?|command\s+help(?:\s+.*)?|show\s+me\s+help(?:\s+.*)?|what\s+can\s+(?:i|you)\s+do(?:\s+.*)?)$/i;

const EASTER_EGGS = [
  { pattern: /miss\s+(?:you|u|ya)\s+kanishk/i, response: 'no' },
];

const ROW_CLASS = 'kay-row flex items-center gap-3 rounded-xl px-3.5 py-2.5 text-left w-full transition-colors hover:bg-black/[0.04]';
const ICON_CLASS = 'flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-black/[0.04] text-sm text-gray-500';
const LOGO_ICON_CLASS = 'flex h-9 w-9 shrink-0 items-center justify-center text-sm text-gray-500';

const PLANE_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.27 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L6 12Z"/></svg>';
const HOTEL_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 19.5V9.75A2.25 2.25 0 0 1 6 7.5h3.75A2.25 2.25 0 0 1 12 9.75v9.75m-8.25-3h16.5m0 3V12a2.25 2.25 0 0 0-2.25-2.25h-3.75A2.25 2.25 0 0 0 12 12v7.5M6.75 11.25h2.25m6 1.5h2.25"/></svg>';
const SEARCH_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"/></svg>';
const BILLING_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5m-18 0h16.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-7.5a1.5 1.5 0 0 1 1.5-1.5Zm0 0v-1.5a1.5 1.5 0 0 1 1.5-1.5h13.5a1.5 1.5 0 0 1 1.5 1.5v1.5"/></svg>';
const TRANSFER_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M7.5 7.5h11.25m0 0-3-3m3 3-3 3M16.5 16.5H5.25m0 0 3 3m-3-3 3-3"/></svg>';
const SPARK_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z"/></svg>';
const REFERRAL_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M15 9h3m0 0V6m0 3-4.5-4.5M9.75 6.75h-1.5A2.25 2.25 0 0 0 6 9v9a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 18V12.75"/></svg>';
const NAV_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6"/></svg>';
const DASHBOARD_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="m3.75 10.5 8.25-6.75 8.25 6.75"/><path stroke-linecap="round" stroke-linejoin="round" d="M5.25 9.75V19.5a.75.75 0 0 0 .75.75h4.5v-5.25c0-.414.336-.75.75-.75h1.5c.414 0 .75.336.75.75v5.25H18a.75.75 0 0 0 .75-.75V9.75"/></svg>';
const EXPLORE_ICON = '<svg class="h-4 w-4" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><path d="M13.46 24.45c-6.29 0-11.389-5.01-11.389-11.2 0-6.19 5.099-11.21 11.389-11.21 6.29 0 11.39 5.02 11.39 11.21 0 6.19-5.1 11.2-11.39 11.2Zm18.228 5.8-8.259-8.13c2.162-2.35 3.491-5.45 3.491-8.87C26.92 5.93 20.894 0 13.46 0 6.026 0 0 5.93 0 13.25c0 7.31 6.026 13.24 13.46 13.24 3.212 0 6.158-1.11 8.472-2.96l8.292 8.16c.405.4 1.06.4 1.464 0 .405-.39.405-1.04 0-1.44Z"/></svg>';
const SETTINGS_ICON = '<svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="3"/><path d="M3.661 10.639c.473.297.777.803.777 1.361 0 .558-.304 1.064-.777 1.361-.321.202-.529.364-.676.556-.323.421-.465.953-.396 1.479.052.394.285.798.751 1.605.466.807.699 1.21 1.014 1.453.421.323.953.465 1.479.396.24-.032.483-.13.819-.308.493-.261 1.084-.271 1.567.008.483.279.769.795.79 1.353.014.38.05.64.143.863.203.49.592.879 1.082 1.082C10.602 22 11.068 22 12 22c.932 0 1.398 0 1.765-.152.49-.203.879-.592 1.082-1.082.093-.223.129-.483.143-.863.021-.558.307-1.074.79-1.353.484-.279 1.074-.269 1.568-.008.335.177.579.276.819.307.526.07 1.058-.073 1.479-.395.315-.243.548-.646 1.014-1.453.466-.807.699-1.21.751-1.605.069-.526-.073-1.058-.396-1.479-.147-.192-.354-.354-.676-.556-.473-.297-.777-.803-.777-1.361 0-.558.304-1.064.777-1.361.322-.202.529-.364.676-.556.323-.421.465-.953.396-1.479-.052-.394-.285-.798-.751-1.605-.466-.807-.699-1.21-1.014-1.453-.421-.323-.953-.465-1.479-.396-.24.032-.483.13-.819.308-.493.261-1.083.271-1.567-.008-.483-.279-.769-.795-.79-1.353-.014-.38-.05-.64-.143-.863-.203-.49-.592-.879-1.082-1.082C13.398 2 12.932 2 12 2c-.932 0-1.398 0-1.765.152-.49.203-.879.592-1.082 1.082-.093.223-.129.483-.143.863-.021.558-.307 1.074-.79 1.353-.484.279-1.074.269-1.568.008-.335-.177-.579-.276-.819-.307-.526-.07-1.058.073-1.479.395-.315.243-.548.646-1.014 1.453-.466.807-.699 1.21-.751 1.605-.069.526.073 1.058.396 1.479.147.192.355.354.676.556Z" stroke-linecap="round"/></svg>';
const MY_FLIGHTS_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="m11.645 20.91-.103-.054c-4.365-2.284-7.292-5.364-7.292-9.496a4.86 4.86 0 0 1 8.25-3.455 4.86 4.86 0 0 1 8.25 3.455c0 4.132-2.927 7.212-7.292 9.496l-.103.054a1.5 1.5 0 0 1-1.71 0Z"/></svg>';
const TOOLS_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M14.25 6.75 17.25 3.75l3 3-3 3"/><path stroke-linecap="round" stroke-linejoin="round" d="M16.5 4.5v6a2.25 2.25 0 0 1-2.25 2.25h-6"/><path stroke-linecap="round" stroke-linejoin="round" d="m9.75 17.25-3 3-3-3 3-3"/><path stroke-linecap="round" stroke-linejoin="round" d="M7.5 19.5v-6A2.25 2.25 0 0 1 9.75 11.25h6"/></svg>';
const CONSULTING_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M8 2.75v2.5m8-2.5v2.5M4.75 7.25h14.5m-13 12h11.5a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5H6.25a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5Z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6M9 15.5h4"/></svg>';
const DOCS_ICON = '<svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.7"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75c-1.25-.722-2.83-1.125-4.5-1.125-1.04 0-2.04.156-3 .444v12.306c.96-.288 1.96-.444 3-.444 1.67 0 3.25.403 4.5 1.125m0-12.306c1.25-.722 2.83-1.125 4.5-1.125 1.04 0 2.04.156 3 .444v12.306c-.96-.288-1.96-.444-3-.444-1.67 0-3.25.403-4.5 1.125m0-12.306v12.306"/></svg>';
const BILLING_QUERY_RE = /\b(?:billing|payments?|invoices?|subscriptions?)\b/i;
const SUBSCRIPTION_QUERY_RE = /\bsubscriptions?\b/i;
const REFERRAL_QUERY_RE = /\b(?:refer|referral|referrals|invite|free credits?)\b/i;
const FREE_TRIAL_QUERY_RE = /\b(?:free trial|day pass|free access|24(?:\s|-)?(?:hour|hours|hr|hrs))\b/i;
const UPGRADE_QUERY_RE = /\b(?:upgrade|pro|premium|pricing|plan)\b/i;
const CONSULTING_QUERY_RE = /^(?:(?:book|schedule|open|show|get)\s+)?(?:(?:a|my|our)\s+)?(?:consult(?:ing|ancy|ation)?|consulting\s+call|strategy\s+call|consultation\s+call|1:1\s+consult(?:ation)?|call\s+with\s+(?:team|pointscasa)|talk\s+to\s+(?:team|someone))(?:\s+(?:call|session))?$/i;
const CONVERSATIONAL_PREFIX_RE = /^(?:please\s+)?(?:(?:can|could|would)\s+you\s+|(?:show|tell|help)\s+me\s+|i\s+(?:want|need)(?:\s+to)?\s+|i(?:\s+would|['’]d)\s+like\s+to\s+|how\s+(?:do\s+i|can\s+i|to)\s+|what\s+can\s+i\s+)/i;
const BALANCE_ENTRY_QUERY_RE = /^(?:(?:i\s*have|i\s+am\s+having|i\s+currently\s+have|currently\s+having|currently\s+have|my\s+balance(?:\s+is)?|my\s+balances?(?:\s+are)?)\b|(?:add|include|put|save|track)\b(?!\s+[\d,]+\b).+(?:\b(?:to|into|in)\s+(?:the\s+|my\s+)?(?:list|portfolio|balances?|cards?|programs?|wallet)\b|\bfor\s+me\b)?$)/i;
const BALANCE_ADD_TO_LIST_RE = /^(?:add|include|put|save|track)\s+(?<body>.+?)(?:\s+(?:to|into|in)\s+(?:the\s+|my\s+)?(?:list|portfolio|balances?|cards?|programs?|wallet)|\s+for\s+me)\s*$/i;
const BALANCE_BARE_ADD_RE = /^(?:add|include|put|save|track)\s+(?<body>.+?)\s*$/i;
const BILLING_COMMAND_RE = /^(?:(?:manage|open|show)\s+)?(?:billing|payments?|invoices?|subscriptions?)(?:\s+(?:settings|portal))?$/i;
const REFERRAL_COMMAND_RE = /^(?:(?:refer|invite)(?:\s+(?:a|my))?\s+(?:friend|friends)|referrals?|free\s+credits?)$/i;
const FREE_TRIAL_COMMAND_RE = /^(?:free\s+trial|day\s+pass|24\s*(?:hour|hours|hr|hrs)(?:\s+(?:free\s+)?access)?|free\s+access)$/i;
const UPGRADE_COMMAND_RE = /^(?:upgrade(?:\s+(?:to\s+)?(?:pro|premium))?|go\s+(?:pro|premium)|open\s+(?:pricing|plans?)|show\s+(?:pricing|plans?))$/i;
const UPDATE_SET_BALANCE_QUERY_RE = /^(?:update|set)\s+.+?\s+(?:to|=)\s+[\d,]+(?:\s*(?:points?|pts?|miles?))?$/i;
const TRANSFER_QUERY_RE = /\btransfers?\b/i;
const DELETE_NATURAL_QUERY_RE = /^(?:i\s+do\s*not\s+have|i\s+don['’]?t\s+have|i(?:\s+am|['’]m)?\s+no\s+longer\s+(?:have|using|keeping|tracking|holding)|(?:remove|delete|drop|untrack|take)\b.+\b(?:from|out\s+of)\s+(?:the\s+|my\s+)?(?:list|portfolio|balances?|cards?|programs?|wallet)\b)/i;
const HOTEL_QUERY_RE = /\b(?:hotels?|stays?)\b/i;
const HOTEL_DATE_QUERY_RE = /\b(?:from|between|on|check[ -]?in)\b|\b(?:for\s+)?(?:\d{1,2}(?:st|nd|rd|th)?\s+(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)|(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\s+\d{1,2}(?:st|nd|rd|th)?)\b/i;
const NAVIGATION_QUERY_CONFIG = [
  { target: 'dashboard', label: 'Dashboard', sub: 'Open your dashboard', command: 'dashboard', icon: DASHBOARD_ICON, aliases: ['home', 'dash'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?(?:dashboard|home)\/?$/i },
  { target: 'explore', label: 'Explore', sub: 'Browse routes and ideas', command: 'explore', icon: EXPLORE_ICON, aliases: ['discover', 'search'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?explore\/?$/i },
  { target: 'hotels', label: 'Hotels', sub: 'Browse hotel stays', command: 'hotels', icon: HOTEL_ICON, aliases: ['hotel', 'stays', 'stay'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?(?:hotels?|stays?)\/?$/i },
  { target: 'flight_explorer', label: 'Flight Explorer', sub: 'Open the full flight explorer', command: 'flight explorer', icon: SEARCH_ICON, aliases: ['explorer flights', 'flight explore', 'flight search explorer'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?(?:flight\s+explorer|explorer\s+flights?)\/?$/i },
  { target: 'settings', label: 'Settings', sub: 'Open your settings', command: 'settings', icon: SETTINGS_ICON, aliases: ['setting', 'prefs', 'preferences'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?settings\/?$/i },
  { target: 'my_flights', label: 'My Flights', sub: 'Open saved searches and results', command: 'my flights', icon: MY_FLIGHTS_ICON, aliases: ['saved flights', 'my flight'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?(?:my\s+flights?|saved\s+flights?)\/?$/i },
  { target: 'tools', label: 'Free Tools', sub: 'Open the tools page', command: 'tools', icon: TOOLS_ICON, aliases: ['free tools', 'tool'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?(?:tools|free\s+tools)\/?$/i },
  { target: 'transfer_calculator', label: 'Transfer Calculator', sub: 'Open the transfer calculator', command: 'transfer calculator', icon: TRANSFER_ICON, aliases: ['points calculator', 'calculator', 'transfer points', 'transfers'], regex: /^(?:(?:go|take\s+me|open|show)\s+(?:to\s+)?)?(?:transfer\s+calculator|points\s+calculator|transfer\s+points?|transfers?)\/?$/i },
];

const HELP_SECTION_DEFINITIONS = [
  {
    title: 'Manage Balances',
    keywords: ['balances', 'balance', 'cards', 'programs', 'portfolio', 'add', 'delete'],
    rows: [
      { icon: '=', label: 'I have 5000 Infinia 12000 Axis Atlas', sub: 'Add or update multiple balances in one go', keywords: ['add balances', 'update balances', 'cards'], command: 'i have 5000 infinia 12000 axis atlas' },
      { icon: '=', label: 'I have Atlas Amex MRCC', sub: 'Add cards now and set balances later', keywords: ['add cards', 'portfolio', 'programs'], command: 'i have atlas amex mrcc' },
      { icon: '?', label: 'Atlas balance', sub: 'Check a current balance', keywords: ['check balance', 'points'], command: 'atlas balance' },
      { icon: 'x', label: 'Delete Atlas and Infinia', sub: 'Remove one or more programs', keywords: ['delete', 'remove', 'programs'], command: 'delete atlas and infinia' },
    ],
  },
  {
    title: 'Find Flights',
    keywords: ['flights', 'flight', 'search', 'routes', 'explorer', 'award'],
    rows: [
      { icon: PLANE_ICON, label: 'Flights from DEL to ATL on 10th march', sub: 'Run an exact dated search', keywords: ['dated search', 'exact date'], command: 'flights from del to atl on 10th march' },
      { icon: SEARCH_ICON, label: 'DEL to Hanoi first week of may', sub: 'Open Flight Explorer with a date range', keywords: ['date range', 'flight explorer', 'week'], command: 'del to hanoi first week of may' },
      { icon: SEARCH_ICON, label: 'Flights from DEL to BKK using 1000 Atlas points', sub: 'Scope Explorer to one balance', keywords: ['using points', 'bookable', 'atlas'], command: 'flights from del to bkk using 1000 atlas points' },
      { icon: PLANE_ICON, label: 'Flights from Delhi to Helsinki business class', sub: 'Apply cabin filters from the command bar', keywords: ['cabin', 'business', 'premium'], command: 'flights from delhi to helsinki business class' },
    ],
  },
  {
    title: 'Find Hotels',
    requiresUrl: 'hotels',
    keywords: ['hotels', 'hotel', 'stays', 'stay', 'rooms'],
    rows: [
      { icon: HOTEL_ICON, label: 'Hotels in Goa', sub: 'Browse cached stays without dates', keywords: ['browse hotels', 'destination'], command: 'hotels in goa' },
      { icon: HOTEL_ICON, label: 'Hotels in Goa from 20 July 2027 to 23 July 2027', sub: 'Run an exact dated hotel search', keywords: ['dated search', 'exact dates'], command: 'hotels in goa from 20 july 2027 to 23 july 2027' },
      { icon: HOTEL_ICON, label: 'Stay in Jaipur on 20 July 2027 for 3 nights', sub: 'Search by number of nights', keywords: ['nights', 'check in'], command: 'stay in jaipur on 20 july 2027 for 3 nights' },
    ],
  },
  {
    title: 'Transfers',
    keywords: ['transfer', 'transfers', 'calculator', 'krisflyer', 'partners'],
    rows: [
      { icon: TRANSFER_ICON, label: 'Transfer Axis Atlas to KrisFlyer 10000', sub: 'Open transfer options for a specific pair', keywords: ['specific transfer', 'krisflyer'], command: 'transfer axis atlas to krisflyer 10000' },
      { icon: TRANSFER_ICON, label: 'Transfer Axis Atlas', sub: 'Browse where a program can transfer', keywords: ['partners', 'browse transfers'], command: 'transfer axis atlas' },
      { icon: TRANSFER_ICON, label: 'How to transfer BizPower to Accor', sub: 'Open the calculator with transfer instructions', keywords: ['instructions', 'accor', 'how to transfer'], command: 'how to transfer bizpower to accor' },
    ],
  },
  {
    title: 'Navigate & Account',
    keywords: ['navigation', 'navigate', 'dashboard', 'explore', 'settings', 'billing', 'refer'],
    rows: [
      { icon: DASHBOARD_ICON, label: 'Dashboard', sub: 'Jump back to your dashboard', keywords: ['dashboard', 'home'], command: 'dashboard' },
      { icon: EXPLORE_ICON, label: 'Explore', sub: 'Open route discovery', keywords: ['explore', 'discover'], command: 'explore' },
      { icon: SETTINGS_ICON, label: 'Settings', sub: 'Open account settings', keywords: ['settings', 'preferences'], command: 'settings' },
      { icon: BILLING_ICON, label: 'Manage Billing', sub: 'Open payment settings', keywords: ['billing', 'payments', 'subscriptions'], command: 'manage billing' },
      { icon: CONSULTING_ICON, label: 'Book a Consultation', sub: 'Open the 1:1 consultation calendar', keywords: ['consultancy', 'consultation', 'consulting', 'call', 'book a call'], command: 'consultancy' },
      { icon: REFERRAL_ICON, label: 'Refer a Friend', sub: 'Open your referral page', keywords: ['referral', 'invite', 'free credits'], command: 'refer a friend' },
    ],
  },
];

const DOCS_LINK_DEFINITIONS = [
  {
    label: 'Start here',
    sub: 'Open PointsCasa docs',
    path: '/introduction',
    keywords: ['docs', 'documentation', 'start here', 'intro', 'introduction', 'guide'],
  },
  {
    label: 'Command Centre docs',
    sub: 'What Command Centre can do',
    path: '/command-centre/using-command-centre',
    keywords: ['command', 'centre', 'center', 'cmd', 'ctrl', 'help', 'what can i do'],
  },
  {
    label: 'What are award flights?',
    sub: 'Understand miles, points, and award seats',
    path: '/getting-started/what-are-award-flights',
    keywords: ['award', 'award flight', 'award flights', 'miles', 'points flight', 'cash flight'],
  },
  {
    label: 'Set your balances',
    sub: 'Add and manage credit card, airline, and hotel balances',
    path: '/points-wallet/managing-programs',
    keywords: ['balance', 'balances', 'wallet', 'programs', 'cards', 'points wallet'],
  },
  {
    label: 'Find flights',
    sub: 'Search routes and understand search behavior',
    path: '/flights/finding-award-flights',
    keywords: ['flight', 'flights', 'search', 'route', 'routes', 'availability'],
  },
  {
    label: 'Understand results',
    sub: 'Read miles, taxes, cabins, routing, and freshness',
    path: '/flights/reading-flight-results',
    keywords: ['results', 'taxes', 'cabins', 'stops', 'freshness', 'routing'],
  },
  {
    label: 'Book a flight',
    sub: 'Use booking paths, optimizer, and transfer steps',
    path: '/flights/book-a-flight',
    keywords: ['book', 'booking', 'optimizer', 'balance mix', 'cash vs points', 'points vs cash'],
  },
  {
    label: 'Live vs cached results',
    sub: 'Understand result freshness',
    path: '/help/live-vs-cached-results',
    keywords: ['live', 'cached', 'cache', 'stale', 'fresh', 'freshness'],
  },
  {
    label: 'Transfer calculator',
    sub: 'Check partners, ratios, transfer times, and bonuses',
    path: '/transfer-calculator/using-transfer-calculator',
    keywords: ['transfer', 'transfers', 'ratio', 'ratios', 'bonus', 'bonuses', 'calculator'],
  },
  {
    label: 'Billing',
    sub: 'Manage pricing, plan, payment, and subscription access',
    path: '/account/billing',
    keywords: ['billing', 'payment', 'payments', 'subscription', 'plan', 'upgrade', 'pro', 'premium', 'price', 'pricing', 'discount', 'lifetime', 'spots', 'yearly', 'monthly', 'day pass'],
  },
  {
    label: 'Referral program',
    sub: 'Share PointsCasa and track referral rewards',
    path: '/account/referral-program',
    keywords: ['refer', 'referral', 'invite', 'free trial', 'free access', 'day pass'],
  },
  {
    label: 'Concierge',
    sub: 'Ask about limited hands-on booking help',
    path: '/help/concierge',
    keywords: ['concierge', 'white glove', 'booking help', 'trip help', 'planning help', 'complex trip', 'personal help'],
  },
];

const DOCS_SEARCH_STOP_WORDS = new Set([
  'a', 'an', 'and', 'are', 'can', 'do', 'does', 'for', 'from', 'how', 'i', 'in',
  'is', 'my', 'of', 'on', 'or', 'the', 'to', 'use', 'using', 'what', 'with', 'you',
]);

const CONTEXT_REGION_DEFINITIONS = {
  north_america: ['north america', 'n america', 'n. america'],
  south_america: ['south america', 's america', 's. america'],
  western_europe: ['western europe', 'west europe', 'w europe', 'w. europe'],
  eastern_europe: ['eastern europe', 'east europe', 'e europe', 'e. europe'],
  middle_east: ['middle east', 'mena'],
  south_asia: ['south asia'],
  southeast_asia: ['southeast asia', 'south east asia', 'se asia'],
  east_asia: ['east asia'],
  oceania: ['oceania'],
  sub_saharan_africa: ['africa', 'sub saharan africa', 'sub-saharan africa'],
};

const CONTEXT_COMPOSITE_REGION_ALIASES = {
  europe: ['western_europe', 'eastern_europe'],
};

const CONTEXT_CABIN_ALIASES = [
  { value: 'premium_economy', patterns: [/\bpremium\s+economy\b/i] },
  { value: 'business', patterns: [/\bbusiness(?:\s+class)?\b/i] },
  { value: 'first', patterns: [/\bfirst(?:\s+class)?\b/i] },
  { value: 'economy', patterns: [/\beconomy(?:\s+class)?\b/i] },
];

const CONTEXT_ROUTE_COMMAND_RE = /^(?:flights?\s+)?(?:find\s+me\s+)?(?:search\s+)?(?:award\s+)?(?:routes?\s+)?(?:from\s+.+?\s+to\s+.+|from\s+.+|to\s+.+)$/i;
const CONTEXT_SCOPE_PREFIX_RE = /^(?<only>only\s+)?(?:(?:using|with)\s+|filter\s+on\s+)(?<scope>.+)$/i;
const CONTEXT_AIRLINES_ONLY_RE = /^(?:only\s+)?(?:show\s+)?(?<scope>.+?)\s+airlines?$/i;
const CONTEXT_SORT_RE = /^(?:sort\s*:?\s*)?(?:by\s+)?(?<field>cash|price|miles|lowest|duration)(?:\s+(?<direction>asc|desc|low(?:est)?\s+to\s+high|high(?:est)?\s+to\s+low))?$/i;
const CONTEXT_RESET_FILTERS_RE = /^(?:reset|clear)\s+(?:all\s+)?filters?$/i;

function normalizeContextValue(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9.\s-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function splitContextList(value) {
  return String(value || '')
    .split(/\s*(?:,|\band\b|\bor\b)\s*/i)
    .map((part) => part.trim())
    .filter(Boolean);
}

function parseContextPassengerCount(value) {
  const exact = parsePassengerCountText(String(value || '').trim());
  if (exact) return exact;
  const inline = extractPassengerCount(String(value || '').trim());
  return inline || 0;
}

function parseContextCabinValue(value) {
  const rawValue = String(value || '').trim();
  for (const candidate of CONTEXT_CABIN_ALIASES) {
    if (candidate.patterns.some((pattern) => pattern.test(rawValue))) {
      return candidate.value;
    }
  }
  return '';
}

function parseContextCabinValues(value) {
  const rawValue = String(value || '').trim();
  if (!rawValue) return [];

  const matched = CONTEXT_CABIN_ALIASES
    .filter((candidate) => candidate.patterns.some((pattern) => pattern.test(rawValue)))
    .map((candidate) => candidate.value);

  return [...new Set(matched)];
}

function stripCabinPhrases(value) {
  let cleanedValue = String(value || '').trim();
  if (!cleanedValue) return '';

  CONTEXT_CABIN_ALIASES.forEach((candidate) => {
    candidate.patterns.forEach((pattern) => {
      cleanedValue = cleanedValue.replace(new RegExp(`\\bin\\s+${pattern.source}`, 'gi'), ' ');
      cleanedValue = cleanedValue.replace(pattern, ' ');
    });
  });

  return cleanedValue.replace(/\s+/g, ' ').trim();
}

function stripScopeNoise(value) {
  return String(value || '')
    .trim()
    .replace(/^(?:only\s+)+/i, '')
    .replace(/^(?:my\s+)+/i, '')
    .replace(/\s+(?:balances?)$/i, '')
    .trim();
}

function formatCabinValue(value) {
  return {
    economy: 'Economy',
    premium_economy: 'Premium Economy',
    business: 'Business',
    first: 'First',
  }[value] || String(value || '').replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

function parseContextSortValue(value) {
  const match = String(value || '').trim().toLowerCase().match(CONTEXT_SORT_RE);
  if (!match?.groups?.field) return '';

  const field = match.groups.field;
  const direction = (match.groups.direction || '').trim();
  if (field === 'duration') {
    return direction === 'desc' || /high/.test(direction) ? 'duration-desc' : 'duration-asc';
  }
  if (field === 'cash' || field === 'price') {
    return direction === 'desc' || /high/.test(direction) ? 'cash-desc' : 'cash-asc';
  }
  return direction === 'desc' || /high/.test(direction) ? 'lowest-desc' : 'lowest-asc';
}

function resolveContextRegionKeys(value) {
  const normalized = normalizeContextValue(value);
  if (!normalized) return [];

  if (CONTEXT_COMPOSITE_REGION_ALIASES[normalized]) {
    return CONTEXT_COMPOSITE_REGION_ALIASES[normalized];
  }

  return Object.entries(CONTEXT_REGION_DEFINITIONS)
    .filter(([, aliases]) => aliases.includes(normalized))
    .map(([key]) => key);
}

function formatContextRegionLabel(key) {
  const labels = {
    north_america: 'North America',
    south_america: 'South America',
    western_europe: 'Western Europe',
    eastern_europe: 'Eastern Europe',
    middle_east: 'Middle East',
    south_asia: 'South Asia',
    southeast_asia: 'Southeast Asia',
    east_asia: 'East Asia',
    oceania: 'Oceania',
    sub_saharan_africa: 'Africa',
  };
  return labels[key] || String(key || '').replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

function isTransferQuery(value) {
  return TRANSFER_QUERY_RE.test(value || '');
}

function getNavigationMatch(value) {
  const query = String(value || '').trim();
  if (!query) return null;
  return NAVIGATION_QUERY_CONFIG.find((item) => item.regex.test(query)) || null;
}

function getNavigationConfig(target) {
  return NAVIGATION_QUERY_CONFIG.find((item) => item.target === target) || null;
}

function getNavigationSuggestions(value) {
  const query = String(value || '').trim().toLowerCase();
  if (!query || query.length < 3) return [];

  const scored = NAVIGATION_QUERY_CONFIG.map((item) => {
    const haystack = [item.label, item.command, item.target, ...(item.aliases || [])]
      .filter(Boolean)
      .map((part) => String(part).toLowerCase());

    let score = 0;
    haystack.forEach((part) => {
      if (part === query) score = Math.max(score, 5);
      else if (part.startsWith(query)) score = Math.max(score, 4);
      else if (query.startsWith(part)) score = Math.max(score, 3);
      else if (part.includes(query)) score = Math.max(score, 2);
    });

    return { item, score };
  })
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score || a.item.label.localeCompare(b.item.label));

  return scored.map(({ item }) => item);
}

function makeDisplayKey(value) {
  return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
}

function uniqueByDisplay(items, getValue) {
  const seen = new Set();
  return items.filter((item) => {
    const key = makeDisplayKey(getValue(item));
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function pushUniqueSuggestion(items, seenKeys, config) {
  const key = makeDisplayKey(config.label);
  if (seenKeys.has(key)) return;
  seenKeys.add(key);
  items.push(makeRow(config));
}

function isMobilePowerMenuViewport() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(max-width: 639px)').matches;
}

function getExecuteHint(action = 'execute') {
  if (isMobilePowerMenuViewport()) {
    return action === 'run' ? 'Tap Run' : `Tap Run to ${action}`;
  }
  return `Press Enter to ${action}`;
}

function getConfirmHint() {
  return isMobilePowerMenuViewport()
    ? 'Tap Run again to confirm, or pick an option below.'
    : 'Press Enter again to confirm, or click below.';
}

function getHelpIntroHint() {
  return isMobilePowerMenuViewport()
    ? 'Tap any example to fill it in, then tap Run.'
    : 'Click any example to fill it in, press → to autocomplete, then Enter to run it.';
}

function adaptCommandHint(text = '') {
  if (!text || !isMobilePowerMenuViewport()) return text;

  return String(text)
    .replace(/Press Enter again to confirm, or click below\./gi, getConfirmHint())
    .replace(/Press Enter to apply/gi, getExecuteHint('apply'))
    .replace(/Press Enter to execute/gi, getExecuteHint('execute'))
    .replace(/Press Enter to run/gi, getExecuteHint('run'))
    .replace(/Press Enter to open transfer options/gi, getExecuteHint('open transfer options'));
}

function appendCenteredHint(container, text = getExecuteHint('execute')) {
  const hint = document.createElement('p');
  hint.className = 'px-3.5 py-4 text-sm text-gray-400 text-center';
  hint.textContent = adaptCommandHint(text);
  container.appendChild(hint);
}

function formatRouteToken(token) {
  const value = (token || '').trim();
  if (!value) return '';
  if (/^[a-z]{3,5}$/i.test(value)) return value.toUpperCase();
  return value.replace(/\b\w/g, (ch) => ch.toUpperCase());
}

function parseRouteShorthandQuery(query) {
  if (UPDATE_SET_BALANCE_QUERY_RE.test(String(query || '').trim())) {
    return null;
  }

  const cleaned = query
    .trim()
    .replace(/^(?:find\s+)?(?:show\s+)?(?:award\s+)?flights?\s+/i, '')
    .replace(/^(?:travel|trip|fly|flying|traveling|search)\s+from\s+/i, '')
    .replace(/^(?:travel|trip|fly|flying|traveling|search)\s+/i, '');

  const leadingDateMatch = cleaned.match(
    /^(?<date>(?:\d{1,2}(?:st|nd|rd|th)?\s+[a-z]+(?:\s*,?\s*\d{4})?|[a-z]+\s+\d{1,2}(?:st|nd|rd|th)?(?:\s*,?\s*\d{4})?|(?:first|1st|second|2nd|third|3rd|fourth|4th|last)\s+week\s+of\s+[a-z]+(?:\s+\d{4})?))\s+(?<origin>.+?)\s+to\s+(?<destination>.+)$/i
  );
  const passengers = extractPassengerCount(query);
  if (leadingDateMatch?.groups?.origin && leadingDateMatch?.groups?.destination) {
    const origin = leadingDateMatch.groups.origin.trim();
    const destination = leadingDateMatch.groups.destination.trim();
    const date = leadingDateMatch.groups.date.trim();
    const hasFlightKeyword = /\b(?:flight|flights|fligh|award|travel|trip|fly|flying|traveling|search)\b/i.test(query);
    if (!hasFlightKeyword && !looksLikePlainRoute(origin, destination)) return null;
    return { origin, destination, date, passengers };
  }

  const match = cleaned.match(/^(?<origin>.+?)\s+to\s+(?<rest>.+)$/i);
  if (!match?.groups?.origin || !match?.groups?.rest) return null;

  let programText = '';
  let balanceText = '';
  let { destination, date, passengers: inlinePassengers } = splitRouteDestinationAndDate(match.groups.rest.trim());
  const passengerCount = inlinePassengers || passengers;
  const usingMatch = destination.match(/^(?<destination>.+?)\s+(?:using(?:\s+my)?|with)\s+(?<scope>.+)$/i);
  if (usingMatch?.groups?.destination && usingMatch?.groups?.scope) {
    destination = usingMatch.groups.destination.trim();
    const scoped = splitTrailingDateConstraint(usingMatch.groups.scope.trim());
    const scopeMatch = parseUsingScopeValue(scoped.value);
    if (scopeMatch) {
      programText = scopeMatch.program;
      balanceText = scopeMatch.amount;
    }
    if (!date && scoped.date) {
      date = scoped.date;
    }
    if (!passengerCount && scoped.passengers) {
      return {
        origin: match.groups.origin.trim(),
        destination,
        date,
        programText,
        balanceText,
        passengers: scoped.passengers,
      };
    }
  } else {
    const inScopeMatch = destination.match(/^(?<destination>.+?)\s+in\s+(?<scope>.+)$/i);
    if (inScopeMatch?.groups?.destination && inScopeMatch?.groups?.scope && !looksLikeDateConstraint(inScopeMatch.groups.scope.trim())) {
      destination = inScopeMatch.groups.destination.trim();
      const scoped = splitTrailingDateConstraint(inScopeMatch.groups.scope.trim());
      const scopeMatch = parseUsingScopeValue(scoped.value);
      if (scopeMatch) {
        programText = scopeMatch.program;
        balanceText = scopeMatch.amount;
      }
      if (!date && scoped.date) {
        date = scoped.date;
      }
      if (!passengerCount && scoped.passengers) {
        return {
          origin: match.groups.origin.trim(),
          destination,
          date,
          programText,
          balanceText,
          passengers: scoped.passengers,
        };
      }
    }
  }
  const hasFlightKeyword = /\b(?:flight|flights|fligh|award|travel|trip|fly|flying|traveling|search)\b/i.test(query);
  if (!destination) return null;
  if (!hasFlightKeyword && !date && !looksLikePlainRoute(match.groups.origin.trim(), destination)) return null;

  return {
    origin: match.groups.origin.trim(),
    destination,
    date,
    programText,
    balanceText,
    passengers: passengerCount,
  };
}

function splitRouteDestinationAndDate(value) {
  const cleanedValue = value.replace(/\s+(?:flight|flights|award|awards)\s*$/i, '').trim();

  const explicitOnMatch = cleanedValue.match(/^(?<destination>.+?)\s+on\s+(?<date>.+)$/i);
  if (explicitOnMatch?.groups?.destination && looksLikeDateConstraint(explicitOnMatch.groups.date.trim())) {
    return {
      destination: explicitOnMatch.groups.destination.replace(/\s+flights?$/i, '').trim(),
      date: explicitOnMatch.groups.date.trim(),
    };
  }

  const explicitInMatch = cleanedValue.match(/^(?<destination>.+?)\s+in\s+(?<date>.+)$/i);
  if (explicitInMatch?.groups?.destination && looksLikeDateConstraint(explicitInMatch.groups.date.trim())) {
    return {
      destination: explicitInMatch.groups.destination.replace(/\s+flights?$/i, '').trim(),
      date: explicitInMatch.groups.date.trim(),
    };
  }

  const explicitForMatch = cleanedValue.match(/^(?<destination>.+?)\s+for\s+(?<date>.+)$/i);
  if (explicitForMatch?.groups?.destination && looksLikeDateConstraint(explicitForMatch.groups.date.trim())) {
    return {
      destination: explicitForMatch.groups.destination.replace(/\s+flights?$/i, '').trim(),
      date: explicitForMatch.groups.date.trim(),
      passengers: 0,
    };
  }
  if (explicitForMatch?.groups?.destination) {
    const passengerCount = parsePassengerCountText(explicitForMatch.groups.date.trim());
    if (passengerCount) {
      return {
        destination: explicitForMatch.groups.destination.replace(/\s+flights?$/i, '').trim(),
        date: '',
        passengers: passengerCount,
      };
    }
  }

  const rangeDateMatch = cleanedValue.match(
    /^(?<destination>.+?)\s+(?<date>(?:first|1st|second|2nd|third|3rd|fourth|4th|last)\s+week\s+of\s+[a-z]+(?:\s+\d{4})?)$/i
  );
  if (rangeDateMatch?.groups?.destination) {
    return {
      destination: rangeDateMatch.groups.destination.replace(/\s+flights?$/i, '').trim(),
      date: rangeDateMatch.groups.date.trim(),
      passengers: 0,
    };
  }

  const bareDateMatch = cleanedValue.match(
    /^(?<destination>.+?)\s+(?<date>(?:\d{1,2}(?:st|nd|rd|th)?\s+[a-z]+(?:\s*,?\s*\d{4})?|[a-z]+\s+\d{1,2}(?:st|nd|rd|th)?(?:\s*,?\s*\d{4})?))$/i
  );
  if (bareDateMatch?.groups?.destination) {
    return {
      destination: bareDateMatch.groups.destination.replace(/\s+flights?$/i, '').trim(),
      date: bareDateMatch.groups.date.trim(),
      passengers: 0,
    };
  }

  return {
    destination: cleanedValue.replace(/\s+flights?$/i, '').trim(),
    date: '',
    passengers: 0,
  };
}

function parsePassengerCountText(value) {
  const cleanedValue = String(value || '').trim();
  const match = cleanedValue.match(/^(?<count>[1-9])(?:\s*(?:pax|passengers?|people|travellers?|travelers?|seats?|tickets?))?$/i);
  return match?.groups?.count ? parseInt(match.groups.count, 10) : 0;
}

function extractPassengerCount(value) {
  const match = String(value || '').match(/\bfor\s+(?<count>[1-9])(?:\s*(?:pax|passengers?|people|travellers?|travelers?|seats?|tickets?))?(?=\s|$)/i);
  return match?.groups?.count ? parseInt(match.groups.count, 10) : 0;
}

function splitTrailingDateConstraint(value) {
  const cleanedValue = String(value || '').trim();
  if (!cleanedValue) {
    return { value: '', date: '', passengers: 0 };
  }

  const explicitOnMatch = cleanedValue.match(/^(?<value>.+?)\s+on\s+(?<date>.+)$/i);
  if (explicitOnMatch?.groups?.value && looksLikeDateConstraint(explicitOnMatch.groups.date.trim())) {
    return {
      value: explicitOnMatch.groups.value.trim(),
      date: explicitOnMatch.groups.date.trim(),
      passengers: 0,
    };
  }

  const explicitInMatch = cleanedValue.match(/^(?<value>.+?)\s+in\s+(?<date>.+)$/i);
  if (explicitInMatch?.groups?.value && looksLikeDateConstraint(explicitInMatch.groups.date.trim())) {
    return {
      value: explicitInMatch.groups.value.trim(),
      date: explicitInMatch.groups.date.trim(),
      passengers: 0,
    };
  }

  const explicitForMatch = cleanedValue.match(/^(?<value>.+?)\s+for\s+(?<date>.+)$/i);
  if (explicitForMatch?.groups?.value && looksLikeDateConstraint(explicitForMatch.groups.date.trim())) {
    return {
      value: explicitForMatch.groups.value.trim(),
      date: explicitForMatch.groups.date.trim(),
      passengers: 0,
    };
  }
  if (explicitForMatch?.groups?.value) {
    const passengerCount = parsePassengerCountText(explicitForMatch.groups.date.trim());
    if (passengerCount) {
      return {
        value: explicitForMatch.groups.value.trim(),
        date: '',
        passengers: passengerCount,
      };
    }
  }

  const rangeDateMatch = cleanedValue.match(
    /^(?<value>.+?)\s+(?<date>(?:first|1st|second|2nd|third|3rd|fourth|4th|last)\s+week\s+of\s+[a-z]+(?:\s+\d{4})?)$/i
  );
  if (rangeDateMatch?.groups?.value) {
    return {
      value: rangeDateMatch.groups.value.trim(),
      date: rangeDateMatch.groups.date.trim(),
      passengers: 0,
    };
  }

  const bareDateMatch = cleanedValue.match(
    /^(?<value>.+?)\s+(?<date>(?:\d{1,2}(?:st|nd|rd|th)?\s+[a-z]+(?:\s*,?\s*\d{4})?|[a-z]+\s+\d{1,2}(?:st|nd|rd|th)?(?:\s*,?\s*\d{4})?))$/i
  );
  if (bareDateMatch?.groups?.value) {
    return {
      value: bareDateMatch.groups.value.trim(),
      date: bareDateMatch.groups.date.trim(),
      passengers: 0,
    };
  }

  return {
    value: cleanedValue,
    date: '',
    passengers: 0,
  };
}

function looksLikeDateConstraint(value) {
  const cleanedValue = normalizeRouteDateText(String(value || '').trim());
  if (!cleanedValue) return false;
  if (/^(?:first|1st|second|2nd|third|3rd|fourth|4th|last)\s+week\s+of\s+[a-z]+(?:\s+\d{4})?$/i.test(cleanedValue)) return true;
  if (/^[a-z]+(?:\s+\d{4})?\s+(?:or|to|-)\s+[a-z]+(?:\s+\d{4})?$/i.test(cleanedValue)) return true;
  if(/^(?:\d{1,2}(?:st|nd|rd|th)?\s+[a-z]+(?:\s*,?\s*\d{4})?|[a-z]+\s+\d{1,2}(?:st|nd|rd|th)?(?:\s*,?\s*\d{4})?)$/i.test(cleanedValue)) return true;
  if (/^[a-z]+(?:\s+\d{4})?$/i.test(cleanedValue)) return true;
  return false;
}

function parseUsingScopeValue(value) {
  const cleanedValue = stripScopeNoise(stripCabinPhrases(value));
  if (!cleanedValue) return null;

  const amountFirstMatch = cleanedValue.match(/^(?<amount>[\d,]+)\s+(?<program>.+?)\s*(?:balances?|points?|pts?|miles?)?$/i);
  if (amountFirstMatch?.groups?.program) {
    return {
      amount: amountFirstMatch.groups.amount.trim(),
      program: stripScopeNoise(amountFirstMatch.groups.program.trim()),
    };
  }

  const amountSuffixMatch = cleanedValue.match(/^(?<program>.+?)\s+(?<amount>[\d,]+)\s*(?:balances?|points?|pts?|miles?)$/i);
  if (amountSuffixMatch?.groups?.program) {
    return {
      amount: amountSuffixMatch.groups.amount.trim(),
      program: stripScopeNoise(amountSuffixMatch.groups.program.trim()),
    };
  }

  const amountSuffixLooseMatch = cleanedValue.match(/^(?<program>.+?)\s+(?<amount>[\d,]+)$/i);
  if (amountSuffixLooseMatch?.groups?.program) {
    return {
      amount: amountSuffixLooseMatch.groups.amount.trim(),
      program: stripScopeNoise(amountSuffixLooseMatch.groups.program.trim()),
    };
  }

  return {
    amount: '',
    program: stripScopeNoise(cleanedValue),
  };
}

function normalizeRouteDateText(value) {
  if (!value) return '';

  const monthMap = {
    jan: 'january',
    feb: 'february',
    mar: 'march',
    apr: 'april',
    jun: 'june',
    jul: 'july',
    aug: 'august',
    sep: 'september',
    sept: 'september',
    oct: 'october',
    nov: 'november',
    dec: 'december',
  };

  return value
    .replace(
      /\b(jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)(\d{4})\b/gi,
      (_, month, year) => `${month} ${year}`,
    )
    .replace(
      /\b(jan|feb|mar|apr|jun|jul|aug|sep|sept|oct|nov|dec)\b/gi,
    (match) => monthMap[match.toLowerCase()] || match,
    );
}

function looksLikePlainRoute(origin, destination) {
  return looksLikeLocationPhrase(origin) && looksLikeLocationPhrase(destination);
}

function looksLikeLocationPhrase(value) {
  const cleaned = value.replace(/[^a-z\s]/gi, ' ').trim().toLowerCase();
  if (!cleaned) return false;

  const tokens = cleaned.split(/\s+/).filter(Boolean);
  if (!tokens.length || tokens.length > 3) return false;

  const blockedTokens = new Set([
    'where', 'what', 'when', 'why', 'how',
    'today', 'tomorrow', 'yesterday',
    'billing', 'upgrade', 'delete', 'balance',
    'points', 'miles', 'pro', 'premium',
  ]);
  if (tokens.some((token) => blockedTokens.has(token))) return false;

  if (tokens.length === 1 && tokens[0].length >= 3) return true;
  return tokens.every((token) => token.length >= 2);
}

function tokenMatches(value, queryPart) {
  const target = (value || '').trim().toLowerCase();
  const query = (queryPart || '').trim().toLowerCase();
  if (!query) return true;
  return target.includes(query) || query.includes(target);
}

function formatPoints(value) {
  if (value === null || value === undefined) return 'Removed';
  if (typeof value === 'number') return `${value.toLocaleString()} points`;
  return String(value);
}

function countTokens(value) {
  return value.split(/\s+/).filter(Boolean).length;
}

function stripConversationalPrefixes(value) {
  let candidate = String(value || '').trim();
  while (true) {
    const updated = candidate.replace(CONVERSATIONAL_PREFIX_RE, '').trim();
    if (updated === candidate) return candidate;
    candidate = updated;
  }
}

function isBalanceEntryPrompt(query) {
  const candidate = stripConversationalPrefixes(String(query || '').trim());
  return BALANCE_ENTRY_QUERY_RE.test(candidate);
}

function getBalanceEntryRemainder(query) {
  const value = stripConversationalPrefixes(String(query || '').trim());
  const addMatch = value.match(BALANCE_ADD_TO_LIST_RE);
  if (addMatch?.groups?.body) {
    return addMatch.groups.body.trim();
  }

  const bareAddMatch = value.match(BALANCE_BARE_ADD_RE);
  if (bareAddMatch?.groups?.body) {
    const body = bareAddMatch.groups.body.trim();
    if (body && !/^[\d,]+\b/.test(body)) {
      return body;
    }
  }

  const prefixMatch = value.match(/^(?:i\s*have|i\s+am\s+having|i\s+currently\s+have|currently\s+having|currently\s+have|my\s+balance(?:\s+is)?|my\s+balances?(?:\s+are)?)\b/i);
  if (!prefixMatch) return '';
  return value.slice(prefixMatch[0].length).trim();
}

function getBalanceEntryPrefix(query) {
  const value = stripConversationalPrefixes(String(query || '').trim());
  const addMatch = value.match(BALANCE_ADD_TO_LIST_RE);
  if (addMatch?.groups?.body) {
    return 'i have ';
  }

  const bareAddMatch = value.match(BALANCE_BARE_ADD_RE);
  if (bareAddMatch?.groups?.body) {
    return 'i have ';
  }

  const prefixMatch = value.match(/^(?:i\s*have|i\s+am\s+having|i\s+currently\s+have|currently\s+having|currently\s+have|my\s+balance(?:\s+is)?|my\s+balances?(?:\s+are)?)\b/i);
  if (!prefixMatch) return 'i have ';
  return `${prefixMatch[0].trim()} `;
}

function endsWithBalanceEntryDelimiter(remainder) {
  return /(?:,(?:\s*)$|\s+\band\s*$)/i.test(String(remainder || ''));
}

function splitBalanceEntryItems(remainder) {
  return String(remainder || '')
    .split(/\s*,\s*|\s+\band\b\s+/i)
    .map((item) => item.trim())
    .filter(Boolean);
}

function getBalanceSearchTerms(query) {
  const remainder = getBalanceEntryRemainder(query);
  const fragments = splitBalanceEntryItems(remainder);
  const activeFragment = endsWithBalanceEntryDelimiter(remainder)
    ? ''
    : (fragments[fragments.length - 1] || remainder);

  return String(activeFragment || '')
    .replace(/\d[\d,]*/g, ' ')
    .replace(/\b(?:points?|point|miles?|mile|and|with|currently|having|have|has|balance|balances|is|are|my|only)\b/gi, ' ')
    .split(/[\s,/-]+/)
    .map((term) => term.trim().toLowerCase())
    .filter((term) => term.length >= 2);
}

function getBalanceTrailingAmount(query) {
  const remainder = getBalanceEntryRemainder(query);
  const match = remainder.match(/(?:^|\s)([\d,]+)\s*(?:points?|pts?|miles?)?\s*$/i);
  return match ? match[1] : '';
}

function normalizeBalanceQueryText(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9,]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function normalizeBalanceToken(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function escapeRegExp(value) {
  return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function buildProgramAliases(program) {
  const aliases = new Set();
  const push = (value) => {
    const normalized = normalizeBalanceToken(value);
    if (normalized) aliases.add(normalized);
  };

  push(program.name);
  push(program.full_name);
  push(program.brand_name);
  push(program.airline_name);
  if (program.brand_name && program.name) push(`${program.brand_name} ${program.name}`);
  if (program.airline_name && program.name) push(`${program.airline_name} ${program.name}`);
  if (program.airline_name && program.full_name) push(`${program.airline_name} ${program.full_name}`);
  (program.search_keywords || []).forEach(push);

  const brand = normalizeBalanceToken(program.brand_name);
  [program.name, program.full_name].filter(Boolean).forEach((value) => {
    const normalized = normalizeBalanceToken(value);
    if (!normalized || !brand) return;
    if (normalized.startsWith(`${brand} `)) {
      push(normalized.slice(brand.length).trim());
    }
  });

  const airline = normalizeBalanceToken(program.airline_name);
  [program.name, program.full_name].filter(Boolean).forEach((value) => {
    const normalized = normalizeBalanceToken(value);
    if (!normalized || !airline) return;
    if (normalized.startsWith(`${airline} `)) {
      push(normalized.slice(airline.length).trim());
    }
  });

  return [...aliases];
}

function getExecutableBalanceProgramName(program) {
  return String(program?.full_name || program?.name || '')
    .replace(/[^A-Za-z0-9&+'/\s.-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function getBalanceProgramKey(program) {
  return String(program?.id || program?.full_name || program?.name || '').trim();
}

function getOwnedBalanceProgramMap(programs) {
  const owned = new Map();
  (Array.isArray(programs) ? programs : []).forEach((program) => {
    const key = getBalanceProgramKey(program);
    if (key && !owned.has(key)) owned.set(key, program);
  });
  return owned;
}

function extractBalanceGapAmount(value) {
  const cleaned = String(value || '')
    .toLowerCase()
    .replace(/\b(?:points?|pts?|miles?)\b/g, ' ')
    .replace(/\b(?:and|with|currently|having|have|has|balance|balances|is|are|my|only)\b/g, ' ')
    .replace(/[^a-z0-9,]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!cleaned) return '';
  if (/^[\d,]+$/.test(cleaned)) return cleaned.replace(/,/g, '');
  return '';
}

function isHelpQuery(value) {
  return HELP_QUERY_RE.test(String(value || '').trim());
}

function isConsultingQuery(value) {
  return CONSULTING_QUERY_RE.test(String(value || '').trim());
}

function isHotelQuery(value) {
  const query = String(value || '').trim();
  return HOTEL_QUERY_RE.test(query) && !/\b(?:balance|points?|pts?|miles?)\b/i.test(query);
}

function getHelpSearchTerms(value) {
  const cleaned = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/^(?:\?|help|show\s+help|command\s+help|show\s+me\s+help|what\s+can\s+(?:i|you)\s+do)\b/, '')
    .trim();

  if (!cleaned) return [];
  return cleaned.split(/\s+/).filter((term) => term.length >= 2);
}

function docsUrl(path = '/introduction') {
  const normalizedPath = String(path || '/introduction').startsWith('/') ? path : `/${path}`;
  return `${DOCS_BASE_URL}${normalizedPath}`;
}

function isDocsCommand(value) {
  const query = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

  return /^(?:open\s+|show\s+|read\s+)?(?:pointscasa\s+)?(?:docs|documentation|guide|start here)$/.test(query);
}

function getDocsMatches(value, { limit = 3, includeDefault = true } = {}) {
  const query = String(value || '').trim().toLowerCase();
  const terms = getHelpSearchTerms(query).filter((term) => (
    term.length >= 3 && !DOCS_SEARCH_STOP_WORDS.has(term)
  ));
  const searchable = [query, ...terms].filter(Boolean);

  const scored = DOCS_LINK_DEFINITIONS.map((item) => {
    const itemText = [item.label, item.sub, ...(item.keywords || [])].join(' ').toLowerCase();
    let score = 0;

    searchable.forEach((term) => {
      if (!term) return;
      const matchesItemText = term.length <= 3
        ? new RegExp(`\\b${escapeRegExp(term)}\\b`).test(itemText)
        : itemText.includes(term);
      if (matchesItemText) score += term.length > 3 ? 2 : 1;
      if ((item.keywords || []).some((keyword) => keyword.toLowerCase() === term)) score += 2;
    });

    (item.keywords || []).forEach((keyword) => {
      const normalizedKeyword = keyword.toLowerCase();
      if (normalizedKeyword.length > 3 && query.includes(normalizedKeyword)) score += 4;
    });

    return { ...item, score };
  })
    .filter((item) => item.score >= 3)
    .sort((a, b) => b.score - a.score);

  if (!scored.length && includeDefault) {
    return [DOCS_LINK_DEFINITIONS[0]];
  }

  return scored.slice(0, limit);
}

function getDocsCommandMatch(value) {
  const query = String(value || '').trim();
  if (!query) return null;

  if (isDocsCommand(query)) {
    return DOCS_LINK_DEFINITIONS[0];
  }

  if (!/\b(?:docs?|documentation|guide)\b/i.test(query)) {
    return null;
  }

  return getDocsMatches(query, {
    limit: 1,
    includeDefault: false,
  })[0] || null;
}

function shouldRequestPreview(value) {
  const query = value.trim().toLowerCase();
  if (!query || query.length < 3) return false;
  if (isHelpQuery(query)) return false;
  if (isConsultingQuery(query)) return false;
  const balanceEntryPrompt = isBalanceEntryPrompt(query);

  const words = countTokens(query);
  const hasNumber = /\d/.test(query);
  const transferQuery = isTransferQuery(query);
  const isBulkDeleteQuery = /^(?:delete|remove|clear)\s+(?:all\b|everything\b)/.test(query);
  const isBalanceQuery = ['balance', 'how many', 'check'].some((k) => query.includes(k));
  const isAddQuery = ['add', 'added', 'increase', 'increased'].some((k) => query.startsWith(k));
  const isSubtractQuery = ['used', 'spent', 'subtract', 'subtracted', 'deduct', 'deducted', 'remove', 'removed', 'reduce', 'reduced']
    .some((k) => query.startsWith(k));
  const isDeleteQuery = /^(?:delete|remove)\b/.test(query) && !/\d/.test(query);
  const routeQuery = parseRouteShorthandQuery(query);
  const isHotelSearch = isHotelQuery(query);
  const isFlightQuery = !isHotelSearch && (['flight', 'flights', 'fligh', 'award', 'from', 'book'].some((k) => query.includes(k)) || Boolean(routeQuery));
  const isBillingQuery = BILLING_QUERY_RE.test(query);
  const isReferralQuery = REFERRAL_QUERY_RE.test(query);
  const isFreeTrialQuery = FREE_TRIAL_QUERY_RE.test(query);
  const isSubscriptionQuery = SUBSCRIPTION_QUERY_RE.test(query);
  const isUpgradeQuery = UPGRADE_QUERY_RE.test(query);
  const navigationMatch = getNavigationMatch(query);

  if (transferQuery) {
    return !/^(?:transfer|transfer to|transfer points|show transfer options for|who can transfer to)$/.test(query);
  }
  if (navigationMatch) return true;
  if (isHotelSearch) return words >= 2;
  if (isBulkDeleteQuery) return true;
  if (UPDATE_SET_BALANCE_QUERY_RE.test(query)) return true;
  if (routeQuery) return true;
  if (isFreeTrialQuery) return true;
  if (isBillingQuery) return words >= 2 || /^(?:billing|payments?|invoices?|subscriptions?)$/.test(query);
  if (isReferralQuery) return words >= 2 || /^(?:referrals?|invite|refer|free credits?)$/.test(query);
  if (isUpgradeQuery || isSubscriptionQuery) return words >= 2 || query === 'upgrade' || isSubscriptionQuery;
  if (isFlightQuery) {
    return (
      query.includes(' from ') ||
      query.startsWith('from ') ||
      query.includes(' to ') ||
      query.includes(' on ') ||
      query.includes(' with ') ||
      query.includes('using') ||
      query.includes('can book')
    );
  }
  if (isDeleteQuery) return words >= 2;
  if (isAddQuery || isSubtractQuery) return hasNumber && words >= 3;
  if (balanceEntryPrompt) return hasNumber && words >= 3;
  if (isBalanceQuery) return words >= 2;
  if (hasNumber) return words >= 2;
  return words >= 3;
}

function getCsrfToken() {
  const tokenFromForm = document.querySelector('[name=csrfmiddlewaretoken]')?.value;
  if (tokenFromForm) return tokenFromForm;
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'csrftoken') return value;
  }
  return '';
}

function formatCommandSuggestionLabel(item) {
  if (!item) return '';
  if (item.intent === 'upgrade_to_pro') return 'Upgrade to Pro';
  if (item.intent === 'manage_billing') return 'Manage Billing';
  if (item.intent === 'refer_friend') return 'Refer a Friend';
  if (item.intent === 'free_trial') return 'Claim 24h Free Access';
  if (item.intent === 'navigate_page') {
    const navigationTarget = item.result_payload?.navigation_target;
    const navigationMatch = getNavigationConfig(navigationTarget);
    if (navigationMatch) return navigationMatch.label;
  }
  return item.raw_input;
}

function getPreviewLabel(value) {
  const input = value.trim().toLowerCase();
  if (!input) return '';
  if (isHelpQuery(input)) return 'Help';
  if (isConsultingQuery(input)) return 'Consultation';
  const navigationMatch = getNavigationMatch(input);
  if (navigationMatch) return 'Navigate';
  if (isHotelQuery(input)) return 'Hotel Search';
  if (isBalanceEntryPrompt(input) && !/\d/.test(input)) return 'Add Programs';
  if (isTransferQuery(input)) return 'Transfer Points';
  if (BILLING_COMMAND_RE.test(input)) return 'Manage Billing';
  if (REFERRAL_COMMAND_RE.test(input)) return 'Refer a Friend';
  if (FREE_TRIAL_COMMAND_RE.test(input)) return 'Free Trial';
  if (UPGRADE_COMMAND_RE.test(input)) return 'Upgrade to Pro';
  if (UPDATE_SET_BALANCE_QUERY_RE.test(input)) return 'Set Balance';
  if (/^(?:delete|remove|clear)\s+(?:all\b|everything\b)/.test(input)) return 'Bulk Delete';
  if ((/^(?:delete|remove)\b/.test(input) || DELETE_NATURAL_QUERY_RE.test(input)) && !/\d/.test(input)) return 'Delete Program';
  if (/^(used|spent|subtract|subtracted|remove|removed|deduct|deducted|reduce|reduced)\b/.test(input)) return 'Subtract Points';
  if (/^(add|added|increase|increased)\b/.test(input)) return 'Add Points';
  if (/\b(?:has|=)\b/.test(input) && /\d/.test(input)) return 'Set Balance';
  if (/\d/.test(input) && !/(flight|award|from|to|on|using|balance|how\s+many|add|added|increase|used|spent|subtract|remove|deduct|reduce|reduced|delete)/.test(input)) return 'Set Balance';
  if (/\b(balance|how\s+many)\b/.test(input)) return 'Show Balance';
  if (parseRouteShorthandQuery(input)) return 'Flight Search';
  if (input.includes('flight') || input.includes('award')) {
    if (input.includes('using') || input.includes('can book') || input.includes(' with ')) return 'Explorer Filters';
    if (input.includes('from') && input.includes('to') && input.includes('on')) return 'Search Flights';
    return 'Flight Explorer';
  }
  return '';
}

function getIntentIcon(intent) {
  switch (intent) {
    case 'set_balance': return '=';
    case 'add_points': return '+';
    case 'subtract_points': return '&minus;';
    case 'show_balance': return '?';
    case 'navigate_page': return NAV_ICON;
    case 'flight_query': return PLANE_ICON;
    case 'hotel_query': return HOTEL_ICON;
    case 'transfer_query': return TRANSFER_ICON;
    case 'manage_billing': return BILLING_ICON;
    case 'refer_friend': return REFERRAL_ICON;
    case 'free_trial': return SPARK_ICON;
    case 'upgrade_to_pro': return SPARK_ICON;
    default: return '&rsaquo;';
  }
}

function getCommandIcon(command) {
  if (!command) return '&rsaquo;';
  if (command.intent === 'navigate_page') {
    return getNavigationConfig(command.result_payload?.navigation_target)?.icon || NAV_ICON;
  }
  return getIntentIcon(command.intent);
}

function commandSupportsProgramLogo(command) {
  if (!command?.intent) return false;
  return [
    'set_balance',
    'add_points',
    'subtract_points',
    'show_balance',
    'delete_program',
    'transfer_query',
  ].includes(command.intent);
}

function appendRowIcon(iconEl, { icon, iconUrl, iconAlt }) {
  const fallbackText = (iconAlt || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();

  const showInitialsFallback = () => {
    if (!fallbackText) {
      iconEl.innerHTML = icon;
      return;
    }
    iconEl.innerHTML = '';
    const fallback = document.createElement('span');
    fallback.className = 'kay-program-fallback';
    fallback.textContent = fallbackText;
    iconEl.appendChild(fallback);
  };

  if (!iconUrl) {
    iconEl.innerHTML = icon;
    return;
  }

  const img = document.createElement('img');
  img.src = iconUrl;
  img.alt = iconAlt || '';
  img.className = 'kay-program-logo';
  img.addEventListener('error', () => {
    showInitialsFallback();
  }, { once: true });
  iconEl.appendChild(img);
}

// Build a Spotlight-style two-line row
function makeRow({ icon, label, sub, onClick, badge, iconUrl, iconAlt, fillCommand = '' }) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = ROW_CLASS;
  btn.dataset.rowKey = makeDisplayKey(label);
  if (fillCommand) {
    btn.dataset.kayFillCommand = fillCommand;
  }

  const iconEl = document.createElement('span');
  iconEl.className = iconUrl ? LOGO_ICON_CLASS : ICON_CLASS;
  appendRowIcon(iconEl, { icon, iconUrl, iconAlt });

  const textCol = document.createElement('div');
  textCol.className = 'min-w-0 flex-1';

  const titleWrap = document.createElement('div');
  titleWrap.className = 'flex min-w-0 items-center gap-2';

  const titleEl = document.createElement('div');
  titleEl.className = 'min-w-0 flex-1 truncate text-sm text-gray-800';
  titleEl.textContent = label;
  titleWrap.appendChild(titleEl);

  if (badge) {
    const badgeEl = document.createElement('span');
    badgeEl.className = `${String(badge).toLowerCase() === 'new' ? 'kay-new-pill' : 'kay-premium-pill'} shrink-0`;
    badgeEl.textContent = badge;
    titleWrap.appendChild(badgeEl);
  }

  textCol.appendChild(titleWrap);

  if (sub) {
    const subEl = document.createElement('div');
    subEl.className = 'text-xs text-gray-400 truncate';
    subEl.textContent = sub;
    textCol.appendChild(subEl);
  }

  btn.appendChild(iconEl);
  btn.appendChild(textCol);
  btn.addEventListener('click', onClick);
  return btn;
}

function makePill({ label, onClick, iconUrl, iconAlt, selected = false }) {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = selected
    ? 'inline-flex items-center gap-2 rounded-full border border-[#3B82F6] bg-[#EEF4FF] px-3 py-2 text-xs text-[#1D4ED8] transition-colors hover:bg-[#E7F0FF]'
    : 'inline-flex items-center gap-2 rounded-full border border-black/[0.08] bg-black/[0.03] px-3 py-2 text-xs text-gray-700 transition-colors hover:bg-black/[0.06]';
  btn.dataset.kayNavItem = 'true';
  btn.dataset.selected = selected ? 'true' : 'false';

  if (iconUrl) {
    const img = document.createElement('img');
    img.src = iconUrl;
    img.alt = iconAlt || label;
    img.className = 'kay-program-logo h-4 w-4 rounded object-contain';
    img.addEventListener('error', () => img.remove(), { once: true });
    btn.appendChild(img);
  }

  const text = document.createElement('span');
  text.textContent = label;
  btn.appendChild(text);
  btn.addEventListener('click', onClick);
  return btn;
}


class PowerMenuController {
  constructor() {
    this.dialog = document.getElementById('power-menu-dialog');
    this.form = document.getElementById('power-menu-form');
    this.input = document.getElementById('power-menu-input');
    this.submitButton = document.getElementById('power-menu-submit');
    this.submitButtonLabel = this.submitButton?.querySelector('[data-power-menu-submit-label]');
    this.preview = document.getElementById('power-menu-preview');
    this.livePreview = document.getElementById('power-menu-live-preview');
    this.previewInterpretation = document.getElementById('power-menu-preview-interpretation');
    this.previewSummary = document.getElementById('power-menu-preview-summary');
    this.previewEffects = document.getElementById('power-menu-preview-effects');
    this.previewHint = document.getElementById('power-menu-preview-hint');
    this.error = document.getElementById('power-menu-error');
    this.resolution = document.getElementById('power-menu-resolution');
    this.resolutionTitle = document.getElementById('power-menu-resolution-title');
    this.resolutionOptions = document.getElementById('power-menu-resolution-options');
    this.suggestionsContainer = document.getElementById('power-menu-suggestions');
    this.isSubmitting = false;
    this.pendingInput = '';
    this.previewTimer = null;
    this.previewController = null;
    this.previewRequestId = 0;
    this.dataLoadPromise = null;
    this.suggestionItems = [];
    this.activeSuggestionIndex = -1;
    this.keyboardSelectionActive = false;
    this.previewSuggestedActions = [];
    this.previewSuggestedInput = '';
    this.helpFallbackMessage = '';
    this.openMode = 'default';
    this.pendingResolution = null;
    this.pendingDeleteKeys = new Set();

    // Cached data from backend
    this.programs = [];
    this.availablePrograms = [];
    this.routes = [];
    this.history = [];
    this.isPremium = false;
    this.hasFreeTrialAvailable = false;
    this.urls = {
      dashboard: '/dashboard/',
      explore: '/dashboard/explore/',
      hotels: '',
      settings: '/dashboard/settings/',
      tools: '/tools/',
      flight_explorer: '/dashboard/flight-explorer/',
      my_flights: '/dashboard/my-flights/',
      transfer_calculator: '/tools/transfer-calculator/',
    };
    this.suggestionsLoaded = false;

    if (!this.dialog || !this.form || !this.input) return;
    this.bindEvents();
    this.restoreCachedData();
    this.scheduleDataWarmup();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-power-menu-trigger]');
      if (!trigger) return;
      event.preventDefault();
      this.open({
        mode: trigger.dataset.powerMenuMode || 'default',
        input: trigger.dataset.powerMenuInput || '',
        nonModal: trigger.dataset.powerMenuNonModal === 'true',
      });
    });

    window.addEventListener('power-menu:open', (event) => {
      const detail = event?.detail || {};
      this.open({
        mode: detail.mode || 'default',
        input: detail.input || '',
        nonModal: detail.nonModal === true,
      });
    });

    document.querySelectorAll('[data-power-menu-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        this.open();
        return;
      }
      if (this.dialog.open && e.target === this.input && e.key === 'ArrowDown' && this.shouldUseSuggestionKeyboardNav()) {
        e.preventDefault();
        this.moveSuggestionSelection(1);
        return;
      }
      if (this.dialog.open && e.target === this.input && e.key === 'ArrowUp' && this.shouldUseSuggestionKeyboardNav()) {
        e.preventDefault();
        this.moveSuggestionSelection(-1);
        return;
      }
      if (this.dialog.open && e.target === this.input && e.key === 'ArrowRight' && this.shouldUseSuggestionKeyboardNav()) {
        const caretAtEnd = this.input.selectionStart === this.input.value.length && this.input.selectionEnd === this.input.value.length;
        if (caretAtEnd && this.keyboardSelectionActive && this.activeSuggestionIndex >= 0) {
          const activeItem = this.suggestionItems[this.activeSuggestionIndex];
          const fillCommand = activeItem?.dataset?.kayFillCommand;
          if (fillCommand) {
            e.preventDefault();
            this.fillAndFocus(fillCommand);
            return;
          }
        }
      }
      if (this.dialog.open && e.key === 'Enter' && e.target === this.input) {
        e.preventDefault();
        if (this.keyboardSelectionActive && this.activeSuggestionIndex >= 0 && this.suggestionItems[this.activeSuggestionIndex]) {
          this.suggestionItems[this.activeSuggestionIndex].click();
          return;
        }
        this.submit();
      }
    });

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });

    this.input.addEventListener('input', () => this.handleInputChange());
    this.dialog.addEventListener('close', () => this.reset());
  }

  open(options = {}) {
    const hasExplicitInput = typeof options.input === 'string' && options.input.trim().length > 0;
    const shouldOpenNonModal = options.nonModal === true;
    this.applyOpenOptions(options);
    this.dialog.dataset.nonModal = shouldOpenNonModal ? 'true' : 'false';
    if (!this.dialog.open) {
      if (shouldOpenNonModal && typeof this.dialog.show === 'function') {
        this.dialog.show();
      } else {
        this.dialog.showModal();
      }
    }
    requestAnimationFrame(() => {
      if (this.shouldAutoFocusOnOpen(hasExplicitInput)) {
        this.focusInputAtEnd();
        return;
      }
      this.input.blur();
    });
    this.handleInputChange({ immediate: true });
    this.loadData();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }

  reset() {
    this.isSubmitting = false;
    this.pendingInput = '';
    this.cancelPreviewRequest();
    this.input.value = '';
    this.hideError();
    this.hideResolution();
    this.hideLivePreview();
    this.clearPreviewSuggestions();
    this.resetSuggestionSelection();
    this.helpFallbackMessage = '';
    this.openMode = 'default';
    this.pendingDeleteKeys = new Set();
    this.updateLayoutMode();
    this.input.placeholder = DEFAULT_PLACEHOLDER;
    this.updatePreview();
    this.renderSuggestions();
  }

  applyOpenOptions(options = {}) {
    this.openMode = options.mode || 'default';
    this.input.placeholder = this.openMode === 'balances' ? BALANCE_MODE_PLACEHOLDER : DEFAULT_PLACEHOLDER;
    if (typeof options.input === 'string') {
      this.input.value = options.input;
    } else if (this.openMode === 'help' && !this.input.value.trim()) {
      this.input.value = 'help';
    } else if (this.openMode === 'balances' && !this.input.value.trim()) {
      this.input.value = 'i have ';
    }
    this.updateLayoutMode();
  }

  shouldAutoFocusOnOpen(hasExplicitInput = false) {
    return !isMobilePowerMenuViewport() || hasExplicitInput || this.openMode === 'balances';
  }

  applyDataPayload(payload = {}) {
    this.history = payload.history || [];
    this.programs = payload.programs || [];
    this.availablePrograms = payload.available_programs || [];
    this.routes = payload.routes || [];
    this.isPremium = Boolean(payload.is_premium);
    this.hasFreeTrialAvailable = Boolean(payload.has_free_trial_available);
    this.urls = { ...this.urls, ...(payload.urls || {}) };
    this.suggestionsLoaded = true;
  }

  restoreCachedData() {
    try {
      const raw = window.sessionStorage.getItem(DATA_CACHE_KEY);
      if (!raw) return;
      const cached = JSON.parse(raw);
      if (!cached?.timestamp || !cached?.payload) return;
      if (Date.now() - cached.timestamp > DATA_CACHE_TTL_MS) return;
      this.applyDataPayload(cached.payload);
    } catch (error) {
      console.warn('[Kay] failed to restore cached suggestions', error);
    }
  }

  writeCachedData() {
    try {
      window.sessionStorage.setItem(DATA_CACHE_KEY, JSON.stringify({
        timestamp: Date.now(),
        payload: {
          history: this.history,
          programs: this.programs,
          available_programs: this.availablePrograms,
          routes: this.routes,
          is_premium: this.isPremium,
          has_free_trial_available: this.hasFreeTrialAvailable,
          urls: this.urls,
        },
      }));
    } catch (error) {
      console.warn('[Kay] failed to cache suggestions', error);
    }
  }

  clearCachedData() {
    try {
      window.sessionStorage.removeItem(DATA_CACHE_KEY);
    } catch (error) {
      console.warn('[Kay] failed to clear cached suggestions', error);
    }
  }

  scheduleDataWarmup() {
    const warm = () => {
      this.loadData({ background: true, forceRefresh: !this.suggestionsLoaded });
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(warm, { timeout: 1200 });
      return;
    }

    window.setTimeout(warm, 250);
  }

  handleInputChange(options = {}) {
    this.pendingInput = '';
    this.keyboardSelectionActive = false;
    this.updatePreview();
    const query = this.input.value.trim();
    if (options.immediate || this.openMode === 'help' || this.openMode === 'balances' || isHelpQuery(query)) {
      this.cancelPreviewRequest();
      this.applySettledInputState(query);
      return;
    }
    this.schedulePreview();
  }

  updateLayoutMode() {
    if (!this.dialog) return;
    const layout = this.openMode === 'help' || isHelpQuery(this.input?.value || '') || Boolean(this.helpFallbackMessage) ? 'help' : 'default';
    this.dialog.dataset.layout = layout;
  }

  updatePreview() {
    const contextualAction = this.input?.value.trim().length >= 3 ? this.buildContextualFlightAction(this.input.value) : null;
    const label = contextualAction?.label || getPreviewLabel(this.input.value);
    this.preview.textContent = label;
    this.preview.classList.toggle('hidden', !label);
    this.updateSubmitButtonState();
  }

  updateSubmitButtonState() {
    if (!this.submitButton) return;
    this.submitButton.disabled = this.isSubmitting || !this.input.value.trim();
    this.submitButton.setAttribute('aria-busy', this.isSubmitting ? 'true' : 'false');
    if (this.submitButtonLabel) {
      this.submitButtonLabel.textContent = this.isSubmitting ? 'Running' : 'Run';
    }
  }

  hideError() {
    this.helpFallbackMessage = '';
    this.error.textContent = '';
    this.error.classList.add('hidden');
    if (this.suggestionsContainer) this.suggestionsContainer.classList.remove('hidden');
  }

  showError(message, { fallbackToHelp = true } = {}) {
    this.hideLivePreview();
    this.resetSuggestionSelection();
    this.clearPreviewSuggestions();
    this.hideResolution();

    if (fallbackToHelp && this.input?.value.trim()) {
      this.helpFallbackMessage = 'fallback';
      this.error.textContent = '';
      this.error.classList.add('hidden');
      if (this.suggestionsContainer) this.suggestionsContainer.classList.remove('hidden');
      this.updateLayoutMode();
      this.renderSuggestions();
      return;
    }

    this.helpFallbackMessage = '';
    this.error.textContent = message;
    this.error.classList.remove('hidden');
    if (this.suggestionsContainer) this.suggestionsContainer.classList.add('hidden');
  }

  hideResolution() {
    this.resolution.classList.add('hidden');
    this.resolutionTitle.textContent = '';
    this.resolutionOptions.innerHTML = '';
    this.pendingResolution = null;
  }

  hideLivePreview() {
    if (!this.livePreview) return;
    this.livePreview.classList.remove('kay-preview-visible');
    if (this.previewInterpretation) {
      this.previewInterpretation.textContent = '';
      this.previewInterpretation.classList.add('hidden');
    }
    if (this.previewHint) this.previewHint.classList.add('hidden');
  }

  clearPreviewSuggestions() {
    this.previewSuggestedActions = [];
    this.previewSuggestedInput = '';
  }

  setPreviewSuggestions(query, actions) {
    this.previewSuggestedInput = String(query || '').trim().toLowerCase();
    this.previewSuggestedActions = Array.isArray(actions) ? actions : [];
  }

  setSubmitting(submitting) {
    this.isSubmitting = submitting;
    this.preview.classList.toggle('kay-executing', submitting);
    if (submitting) {
      this.cancelPreviewRequest();
      this.preview.textContent = 'Running...';
      this.preview.classList.remove('hidden');
      this.preview.style.color = '#fff';
      this.preview.style.background = '#22c55e';
    } else {
      this.preview.style.color = '';
      this.preview.style.background = '';
      this.updatePreview();
    }
    this.input.toggleAttribute('disabled', submitting);
    this.updateSubmitButtonState();
  }

  focusInputAtEnd() {
    if (!this.dialog?.open || !this.input || this.input.disabled) return;
    requestAnimationFrame(() => {
      this.input.focus();
      const end = this.input.value.length;
      this.input.setSelectionRange(end, end);
    });
  }

  cancelPreviewRequest() {
    if (this.previewTimer) {
      window.clearTimeout(this.previewTimer);
      this.previewTimer = null;
    }
    if (this.previewController) {
      this.previewController.abort();
      this.previewController = null;
    }
  }

  applySettledInputState(inputValue = this.input.value.trim()) {
    const settledInput = String(inputValue || '').trim();
    if (settledInput !== this.input.value.trim()) return;

    this.clearPreviewSuggestions();
    this.hideError();
    this.hideResolution();
    this.updateLayoutMode();

    if (!settledInput || this.isSubmitting) {
      this.renderSuggestions();
      this.hideLivePreview();
      return;
    }

    const contextualAction = this.buildContextualFlightAction(settledInput);
    if (contextualAction) {
      this.renderLivePreview(contextualAction.previewData);
      this.renderSuggestions();
      return;
    }

    const pendingDeletePrograms = (this.pendingDeleteKeys.size > 0 && isBalanceEntryPrompt(settledInput))
      ? (this.programs || []).filter((p) => this.pendingDeleteKeys.has(getBalanceProgramKey(p)))
      : [];

    if (this.renderLocalBalanceSelectionPreview(settledInput)) {
      if (pendingDeletePrograms.length) this.appendPendingDeleteRows(pendingDeletePrograms);
      this.renderSuggestions();
      return;
    }

    if (pendingDeletePrograms.length) {
      this.renderPendingDeletePreview();
      this.renderSuggestions();
      return;
    }

    this.renderSuggestions();

    if (!shouldRequestPreview(settledInput)) {
      this.hideLivePreview();
      return;
    }

    this.fetchPreview(settledInput);
  }

  schedulePreview() {
    const inputValue = this.input.value.trim();
    this.cancelPreviewRequest();

    this.previewTimer = window.setTimeout(() => {
      this.previewTimer = null;
      this.applySettledInputState(inputValue);
    }, INPUT_SETTLE_DELAY_MS);
  }

  async fetchPreview(inputValue) {
    const requestId = ++this.previewRequestId;
    this.previewController = new AbortController();

    try {
      const response = await fetch(PREVIEW_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCsrfToken(),
        },
        body: JSON.stringify({
          input: inputValue,
          context: {
            path: window.location.pathname,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }),
        signal: this.previewController.signal,
      });

      const data = await response.json();
      if (requestId !== this.previewRequestId || inputValue !== this.input.value.trim()) {
        return;
      }

      if (data.status === 'needs_resolution') {
        this.clearPreviewSuggestions();
        this.hideError();
        this.hideLivePreview();
        this.renderResolution(data);
        this.renderSuggestions();
        return;
      }

      if (!response.ok || data.status !== 'ok') {
        this.clearPreviewSuggestions();
        this.hideLivePreview();
        this.hideResolution();
        this.hideError();
        this.renderSuggestions();
        return;
      }

      this.setPreviewSuggestions(inputValue, data.suggested_actions || []);
      this.hideError();
      this.hideResolution();
      this.renderLivePreview(data);
      this.renderSuggestions();
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('[Kay] preview failed', error);
      this.clearPreviewSuggestions();
      this.hideLivePreview();
      this.hideResolution();
      this.hideError();
      this.renderSuggestions();
    } finally {
      if (requestId === this.previewRequestId) {
        this.previewController = null;
      }
    }
  }

  renderLivePreview(data) {
    if (!this.livePreview || !this.previewSummary || !this.previewEffects) return;

    const summary = (data.summary || '').trim();
    const effects = Array.isArray(data.effects_preview) ? data.effects_preview : [];
    const details = Array.isArray(data.details_preview) ? data.details_preview : [];

    if (!summary && effects.length === 0 && details.length === 0) {
      this.hideLivePreview();
      return;
    }

    this.livePreview.classList.add('kay-preview-visible');
    if (this.previewInterpretation) {
      const interpretedInput = String(data.interpreted_input || '').trim();
      if (interpretedInput && interpretedInput.toLowerCase() !== this.input.value.trim().toLowerCase()) {
        this.previewInterpretation.textContent = `Interpreting this as: ${interpretedInput}`;
        this.previewInterpretation.classList.remove('hidden');
      } else {
        this.previewInterpretation.textContent = '';
        this.previewInterpretation.classList.add('hidden');
      }
    }
    this.previewSummary.textContent = summary;
    this.previewEffects.innerHTML = '';
    if (this.previewHint) {
      const hintText = adaptCommandHint(data.hint || (data.status === 'ok' ? getExecuteHint('execute') : ''));
      if (hintText) {
        this.previewHint.textContent = hintText;
        this.previewHint.classList.remove('hidden');
      } else {
        this.previewHint.classList.add('hidden');
      }
    }

    effects.forEach((effect, i) => {
      const row = document.createElement('div');
      row.className = 'kay-preview-row flex items-center justify-between gap-3 px-4 py-3';
      row.style.animationDelay = `${i * 40}ms`;
      const effectLogoUrl = effect.logo_url || this.findProgramMeta(effect.program)?.logo_url;
      const effectInitials = (effect.program || '')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0])
        .join('')
        .toUpperCase();

      const labelWrap = document.createElement('div');
      labelWrap.className = 'flex min-w-0 items-center gap-3';

      if (effectLogoUrl) {
        const logo = document.createElement('img');
        logo.src = effectLogoUrl;
        logo.alt = effect.program || '';
        logo.className = 'kay-program-logo shrink-0';
        logo.addEventListener('error', () => {
          logo.remove();
          if (effectInitials && !labelWrap.querySelector('.kay-program-fallback')) {
            const fallback = document.createElement('span');
            fallback.className = 'kay-program-fallback shrink-0';
            fallback.textContent = effectInitials;
            labelWrap.prepend(fallback);
          }
        }, { once: true });
        labelWrap.appendChild(logo);
      } else if (effectInitials) {
        const fallback = document.createElement('span');
        fallback.className = 'kay-program-fallback shrink-0';
        fallback.textContent = effectInitials;
        labelWrap.appendChild(fallback);
      }

      const label = document.createElement('div');
      label.className = 'truncate text-sm text-gray-700';
      label.textContent = effect.program;
      labelWrap.appendChild(label);

      const value = document.createElement('div');
      value.className = 'text-xs text-gray-500 text-right';
      if (typeof effect.current_balance === 'number') {
        value.textContent = formatPoints(effect.current_balance);
      } else if (effect.current_balance === null) {
        value.textContent = 'Not in portfolio';
      } else {
        value.textContent = `${formatPoints(effect.before_balance)} → ${formatPoints(effect.after_balance)}`;
      }

      row.appendChild(labelWrap);
      row.appendChild(value);
      this.previewEffects.appendChild(row);
    });

    details.forEach((detail, i) => {
      const row = document.createElement('div');
      row.className = 'kay-preview-row flex items-center justify-between gap-3 px-4 py-3';
      row.style.animationDelay = `${(effects.length + i) * 40}ms`;

      const label = document.createElement('div');
      label.className = 'text-xs font-medium uppercase tracking-[0.08em] text-gray-400';
      label.textContent = detail.label;

      const valueWrap = document.createElement('div');
      valueWrap.className = 'flex items-center justify-end gap-2 text-right';

      if (detail.logo_url) {
        const logo = document.createElement('img');
        logo.src = detail.logo_url;
        logo.alt = detail.value || '';
        logo.className = 'kay-program-logo shrink-0';
        logo.addEventListener('error', () => {
          logo.remove();
        }, { once: true });
        valueWrap.appendChild(logo);
      }

      const value = document.createElement('div');
      value.className = 'text-sm text-gray-700';
      value.textContent = detail.value;
      valueWrap.appendChild(value);

      row.appendChild(label);
      row.appendChild(valueWrap);
      this.previewEffects.appendChild(row);
    });
  }

  renderLocalBalanceSelectionPreview(inputValue) {
    const query = String(inputValue || '').trim().toLowerCase();
    if (!isBalanceEntryPrompt(query)) {
      return false;
    }

    const selectedPrograms = this.getSelectedBalanceProgramEntries(query);
    if (!selectedPrograms.length) {
      return false;
    }

    const ownedKeys = new Set((this.programs || []).map((program) => getBalanceProgramKey(program)));
    const missingPrograms = selectedPrograms.filter((program) => !ownedKeys.has(getBalanceProgramKey(program)));
    const existingPrograms = selectedPrograms.filter((program) => ownedKeys.has(getBalanceProgramKey(program)));
    const programsWithAmounts = selectedPrograms.filter((program) => program.amount);
    const existingProgramsWithAmounts = programsWithAmounts.filter((program) => ownedKeys.has(getBalanceProgramKey(program)));
    const missingProgramsWithAmounts = programsWithAmounts.filter((program) => !ownedKeys.has(getBalanceProgramKey(program)));

    this.hideError();
    this.hideResolution();
    this.clearPreviewSuggestions();

    if (!this.livePreview || !this.previewSummary || !this.previewEffects) {
      return true;
    }

    this.livePreview.classList.add('kay-preview-visible');
    if (this.previewInterpretation) {
      this.previewInterpretation.textContent = '';
      this.previewInterpretation.classList.add('hidden');
    }
    this.previewEffects.innerHTML = '';

    const makePreviewRow = (program, statusText) => {
      const row = document.createElement('div');
      row.className = 'kay-preview-row flex items-center justify-between gap-3 px-4 py-3';

      const labelWrap = document.createElement('div');
      labelWrap.className = 'flex min-w-0 items-center gap-3';

      if (program.logo_url) {
        const logo = document.createElement('img');
        logo.src = program.logo_url;
        logo.alt = program.full_name || program.name;
        logo.className = 'kay-program-logo shrink-0';
        labelWrap.appendChild(logo);
      }

      const label = document.createElement('div');
      label.className = 'truncate text-sm text-gray-700';
      label.textContent = program.name;
      labelWrap.appendChild(label);

      const value = document.createElement('div');
      value.className = 'text-xs text-gray-500 text-right';
      value.textContent = statusText;

      row.appendChild(labelWrap);
      row.appendChild(value);
      this.previewEffects.appendChild(row);
    };

    if (missingPrograms.length > 0) {
      if (existingProgramsWithAmounts.length > 0) {
        this.previewSummary.textContent = `Add ${missingPrograms.length} program${missingPrograms.length === 1 ? '' : 's'} and update ${existingProgramsWithAmounts.length} existing balance${existingProgramsWithAmounts.length === 1 ? '' : 's'}`;
      } else if (existingPrograms.length > 0) {
        this.previewSummary.textContent = `Add ${missingPrograms.length} program${missingPrograms.length === 1 ? '' : 's'} and keep ${existingPrograms.length} already in your portfolio`;
      } else if (missingProgramsWithAmounts.length > 0) {
        this.previewSummary.textContent = `Add ${missingPrograms.length} program${missingPrograms.length === 1 ? '' : 's'} with ${missingProgramsWithAmounts.length} balance${missingProgramsWithAmounts.length === 1 ? '' : 's'} set`;
      } else {
        this.previewSummary.textContent = missingPrograms.length === 1
          ? `Add ${missingPrograms[0].name} to your portfolio`
          : `Add ${missingPrograms.length} programs to your portfolio`;
      }
      if (this.previewHint) this.previewHint.classList.remove('hidden');
      selectedPrograms.forEach((program) => {
        const status = program.amount
          ? `${ownedKeys.has(getBalanceProgramKey(program)) ? 'Will update to' : 'Will be added at'} ${Number(String(program.amount).replace(/,/g, '')).toLocaleString()} points`
          : ownedKeys.has(getBalanceProgramKey(program)) ? 'Already added' : 'Will be added';
        makePreviewRow(program, status);
      });
      return true;
    }

    if (existingProgramsWithAmounts.length > 0) {
      this.previewSummary.textContent = existingProgramsWithAmounts.length === 1
        ? `Update ${existingProgramsWithAmounts[0].name} balance`
        : `Update ${existingProgramsWithAmounts.length} balances`;
      if (this.previewHint) this.previewHint.classList.remove('hidden');
      selectedPrograms.forEach((program) => {
        const status = program.amount
          ? `Will update to ${Number(String(program.amount).replace(/,/g, '')).toLocaleString()} points`
          : 'Already added';
        makePreviewRow(program, status);
      });
      return true;
    }

    this.previewSummary.textContent = 'These programs are already in your portfolio';
    if (this.previewHint) this.previewHint.classList.add('hidden');
    selectedPrograms.forEach((program) => {
      makePreviewRow(program, 'Already added');
    });
    return true;
  }

  // ── Data loading ──

  async loadData({ background = false, forceRefresh = false } = {}) {
    if (this.suggestionsLoaded && !forceRefresh) {
      if (!background) this.refreshAfterProgramDataAvailable();
      return;
    }

    if (this.dataLoadPromise && !forceRefresh) {
      if (!background) {
        await this.dataLoadPromise;
        this.refreshAfterProgramDataAvailable();
      }
      return;
    }

    this.dataLoadPromise = (async () => {
      try {
        const [histRes, sugRes] = await Promise.all([
          fetch(HISTORY_URL),
          fetch(SUGGESTIONS_URL),
        ]);
        const histData = await histRes.json();
        const sugData = await sugRes.json();

        this.applyDataPayload({
          history: histData.commands || [],
          programs: sugData.programs || [],
          available_programs: sugData.available_programs || [],
          routes: sugData.routes || [],
          is_premium: sugData.is_premium,
          has_free_trial_available: sugData.has_free_trial_available,
          urls: sugData.urls || {},
        });
        this.writeCachedData();

        if (this.dialog.open) {
          this.renderSuggestions();
        }
      } catch (err) {
        console.error('[Kay] data load failed', err);
        if (this.dialog.open) {
          this.renderSuggestions();
        }
      } finally {
        this.dataLoadPromise = null;
      }
    })();

    if (!background) {
      await this.dataLoadPromise;
    }
  }

  refreshAfterProgramDataAvailable() {
    this.renderSuggestions();
  }

  // ── Smart suggestions engine ──

  renderSuggestions() {
    if (!this.suggestionsContainer) return;

    const query = this.input.value.trim().toLowerCase();
    const container = this.suggestionsContainer;
    container.innerHTML = '';
    this.resetSuggestionSelection();

    if (this.helpFallbackMessage) {
      this.renderHelpMode(container, this.input?.value || 'help', {
        disclaimer: 'Couldn’t confidently understand that yet.',
      });
      return;
    }

    if (isHelpQuery(query)) {
      this.renderHelpMode(container, query);
      return;
    }

    const egg = EASTER_EGGS.find((e) => e.pattern.test(query));
    if (egg) {
      this.renderEasterEgg(container, egg.response);
      return;
    }

    if (!query) {
      this.renderEmpty(container);
      return;
    }

    const previewItems = this.getPreviewSuggestedRows(query);
    const items = previewItems.length > 0 ? previewItems : this.getSuggestionsForQuery(query);
    const shouldShowBalancePicker = this.shouldShowBalanceProgramPicker(query);
    const shouldShowNeutralHelp = query.length >= 6 || countTokens(query) >= 2;

    if (items.length === 0 && !shouldShowBalancePicker) {
      if (this.livePreview && this.livePreview.classList.contains('kay-preview-visible')) {
        appendCenteredHint(container, getExecuteHint('apply'));
        this.captureSuggestionItems();
        return;
      }
      if (!shouldShowNeutralHelp) {
        this.renderEmpty(container);
        return;
      }
      this.renderHelpMode(container, query);
      return;
    }

    if (shouldShowBalancePicker) {
      this.renderBalanceProgramPicker(container);
    }

    if (items.length === 0) {
      if (shouldShowBalancePicker) {
        this.captureSuggestionItems();
        return;
      }
      if (this.livePreview && this.livePreview.classList.contains('kay-preview-visible')) {
        appendCenteredHint(container);
        this.captureSuggestionItems();
        return;
      }
      if (!shouldShowNeutralHelp) {
        this.renderEmpty(container);
        return;
      }
      this.renderHelpMode(container, query);
      return;
    }

    const label = document.createElement('p');
    label.className = 'px-3.5 pb-2 pt-1 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
    label.textContent = 'Suggestions';
    container.appendChild(label);

    const list = document.createElement('div');
    list.className = 'flex flex-col';
    items.forEach((item) => list.appendChild(item));
    container.appendChild(list);

    const docsMatches = getDocsMatches(query, {
      limit: 1,
      includeDefault: false,
    });
    if (docsMatches.length) {
      const docsLabel = document.createElement('p');
      docsLabel.className = 'px-3.5 pb-2 pt-3 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
      docsLabel.textContent = 'Docs';
      container.appendChild(docsLabel);

      const docsList = document.createElement('div');
      docsList.className = 'flex flex-col';
      docsMatches.forEach((item) => {
        docsList.appendChild(makeRow({
          icon: DOCS_ICON,
          label: item.label,
          sub: item.sub,
          badge: 'new',
          onClick: () => this.navigateTo(docsUrl(item.path)),
        }));
      });
      container.appendChild(docsList);
    }

    this.captureSuggestionItems();
  }

  renderEasterEgg(container, message) {
    if (this.dialog) this.dialog.dataset.layout = 'default';
    const wrapper = document.createElement('div');
    wrapper.className = 'flex items-center justify-center py-12';
    const text = document.createElement('p');
    text.className = 'text-2xl font-medium text-gray-800';
    text.textContent = message;
    wrapper.appendChild(text);
    container.appendChild(wrapper);
  }

  renderHelpMode(container, query, options = {}) {
    if (this.dialog) {
      this.dialog.dataset.layout = 'help';
    }
    const disclaimer = String(options.disclaimer || '').trim();
    const normalizedDisclaimer = disclaimer.replace(/[’]/g, "'").toLowerCase();
    const isGenericDisclaimer = normalizedDisclaimer === "couldn't confidently understand that yet.";
    const intro = document.createElement('div');
    intro.className = 'kay-help-intro mx-3.5 mt-1 mb-3';

    const title = document.createElement('p');
    title.className = 'text-sm text-gray-800';
    title.textContent = disclaimer
      ? "Couldn't confidently understand that yet."
      : 'Here are a few things we can do from Command Center.';
    intro.appendChild(title);

    if (disclaimer && !isGenericDisclaimer) {
      const message = document.createElement('p');
      message.className = 'mt-1 text-xs text-gray-500';
      message.textContent = disclaimer;
      intro.appendChild(message);
    }

    if (disclaimer) {
      const helper = document.createElement('p');
      helper.className = 'mt-2 text-xs text-gray-500';
      helper.textContent = 'Here are a few things you can do instead.';
      intro.appendChild(helper);
    }

    const sub = document.createElement('p');
    sub.className = 'mt-1 text-xs text-gray-500';
    sub.textContent = getHelpIntroHint();
    intro.appendChild(sub);
    container.appendChild(intro);

    const helpGrid = document.createElement('div');
    helpGrid.className = 'kay-help-grid px-3.5 pb-3';

    const searchTerms = getHelpSearchTerms(query);
    const docsMatches = getDocsMatches(query, {
      limit: disclaimer ? 3 : 2,
      includeDefault: true,
    });
    if (docsMatches.length) {
      const docsSection = document.createElement('section');
      docsSection.className = 'kay-help-section';

      const docsTitle = document.createElement('p');
      docsTitle.className = 'pb-2 text-[11px] font-medium uppercase tracking-[0.08em] text-gray-400';
      docsTitle.textContent = disclaimer ? 'Related docs' : 'Docs';
      docsSection.appendChild(docsTitle);

      const docsList = document.createElement('div');
      docsList.className = 'flex flex-col gap-1.5';
      docsMatches.forEach((item) => {
        docsList.appendChild(makeRow({
          icon: DOCS_ICON,
          label: item.label,
          sub: item.sub,
          badge: 'new',
          onClick: () => this.navigateTo(docsUrl(item.path)),
        }));
      });
      docsSection.appendChild(docsList);
      helpGrid.appendChild(docsSection);
    }

    const sections = this.buildHelpSections(searchTerms);

    sections.forEach((section) => {
      const sectionEl = document.createElement('section');
      sectionEl.className = 'kay-help-section';

      const title = document.createElement('p');
      title.className = 'pb-2 text-[11px] font-medium uppercase tracking-[0.08em] text-gray-400';
      title.textContent = section.title;
      sectionEl.appendChild(title);

      const list = document.createElement('div');
      list.className = 'flex flex-col gap-1.5';
      section.rows.forEach((row) => list.appendChild(makeRow(row)));
      sectionEl.appendChild(list);
      helpGrid.appendChild(sectionEl);
    });

    if (!sections.length) {
      if (helpGrid.children.length) {
        container.appendChild(helpGrid);
        this.captureSuggestionItems();
        return;
      }

      const hint = document.createElement('p');
      hint.className = 'px-3.5 py-4 text-sm text-gray-400 text-center';
      hint.textContent = 'Try “help flights”, “help hotels”, “help balances”, or “help transfers”.';
      container.appendChild(hint);
      this.captureSuggestionItems();
      return;
    }

    container.appendChild(helpGrid);
    this.captureSuggestionItems();
  }

  renderEmpty(container) {
    if (this.openMode === 'balances') {
      this.renderBalanceModeEmpty(container);
      return;
    }

    const docsLabel = document.createElement('p');
    docsLabel.className = 'px-3.5 pb-2 pt-1 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
    docsLabel.textContent = 'Start here';
    container.appendChild(docsLabel);

    const docsList = document.createElement('div');
    docsList.className = 'flex flex-col';
    docsList.appendChild(makeRow({
      icon: DOCS_ICON,
      label: 'PointsCasa Docs',
      sub: 'Read the basics and learn how to use PointsCasa',
      badge: 'new',
      onClick: () => this.navigateTo(docsUrl('/introduction')),
    }));
    container.appendChild(docsList);

    // Show history first, then fallback commands
    const seenRowKeys = new Set();
    const uniqueHistory = uniqueByDisplay(this.history, (cmd) => formatCommandSuggestionLabel(cmd));
    if (uniqueHistory.length > 0) {
      const label = document.createElement('p');
      label.className = 'px-3.5 pb-2 pt-1 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
      label.textContent = 'Recent';
      container.appendChild(label);

      const list = document.createElement('div');
      list.className = 'flex flex-col';
      uniqueHistory.forEach((cmd) => {
        const matchedProgram = commandSupportsProgramLogo(cmd) ? this.findProgramMeta(cmd.raw_input) : null;
        seenRowKeys.add(makeDisplayKey(formatCommandSuggestionLabel(cmd)));
        list.appendChild(makeRow({
          icon: getCommandIcon(cmd),
          label: formatCommandSuggestionLabel(cmd),
          sub: cmd.summary || '',
          iconUrl: matchedProgram?.logo_url,
          iconAlt: matchedProgram?.full_name || matchedProgram?.name || '',
          fillCommand: cmd.raw_input,
          onClick: () => this.fillAndSubmit(cmd.raw_input),
        }));
      });
      container.appendChild(list);
    }

    // Always show action shortcuts
    const actLabel = document.createElement('p');
    actLabel.className = 'px-3.5 pb-2 pt-3 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
    actLabel.textContent = uniqueHistory.length > 0 ? 'Quick actions' : 'Try something';
    container.appendChild(actLabel);

    const actList = document.createElement('div');
    actList.className = 'flex flex-col';

    const quickActions = this.buildQuickActions().filter((item) => {
      const key = item.dataset.rowKey;
      if (!key || seenRowKeys.has(key)) return false;
      seenRowKeys.add(key);
      return true;
    });
    quickActions.forEach((item) => actList.appendChild(item));
    container.appendChild(actList);
    this.captureSuggestionItems();
  }

  renderBalanceModeEmpty(container) {
    const examplesLabel = document.createElement('p');
    examplesLabel.className = 'px-3.5 pb-2 pt-1 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
    examplesLabel.textContent = 'Add balances';
    container.appendChild(examplesLabel);

    const examples = document.createElement('div');
    examples.className = 'flex flex-col';
    [
      {
        label: 'I have 5000 Infinia',
        sub: 'Add or update one balance',
        icon: '=',
        fillCommand: 'i have 5000 infinia',
        onClick: () => this.fillAndFocus('i have 5000 infinia'),
      },
      {
        label: 'I have 5000 Infinia 12000 Axis Atlas',
        sub: 'Add multiple balances in one go',
        icon: '=',
        fillCommand: 'i have 5000 infinia 12000 axis atlas',
        onClick: () => this.fillAndFocus('i have 5000 infinia 12000 axis atlas'),
      },
      {
        label: 'My balance is 5000 Atlas',
        sub: 'Natural language works too',
        icon: '=',
        fillCommand: 'my balance is 5000 atlas',
        onClick: () => this.fillAndFocus('my balance is 5000 atlas'),
      },
    ].forEach((item) => examples.appendChild(makeRow(item)));
    container.appendChild(examples);

    const quickLabel = document.createElement('p');
    quickLabel.className = 'px-3.5 pb-2 pt-3 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
    quickLabel.textContent = 'Quick actions';
    container.appendChild(quickLabel);

    const quickList = document.createElement('div');
    quickList.className = 'flex flex-col';
    this.buildBalanceModeQuickActions().forEach((item) => quickList.appendChild(item));
    container.appendChild(quickList);

    if (this.availablePrograms.length > 0) {
      const pickerLabel = document.createElement('p');
      pickerLabel.className = 'px-3.5 pb-2 pt-3 text-[11px] font-medium uppercase tracking-[0.1em] text-gray-400';
      pickerLabel.textContent = 'All cards & programs';
      container.appendChild(pickerLabel);
      this.renderBalanceProgramPicker(container);
    }
    this.captureSuggestionItems();
  }

  shouldShowBalanceProgramPicker(query) {
    return this.availablePrograms.length > 0 && (this.openMode === 'balances' || isBalanceEntryPrompt(query));
  }

  renderBalanceProgramPicker(container) {
    const query = this.input.value.trim().toLowerCase();
    const searchTerms = getBalanceSearchTerms(query);
    const ownedPrograms = getOwnedBalanceProgramMap(this.programs);

    const activeOwnedMap = new Map();
    const pendingDeleteMap = new Map();
    ownedPrograms.forEach((program, key) => {
      if (this.pendingDeleteKeys.has(key)) {
        pendingDeleteMap.set(key, program);
      } else {
        activeOwnedMap.set(key, program);
      }
    });

    const sourcePrograms = this.filterBalancePrograms(searchTerms)
      .filter((program) => !ownedPrograms.has(getBalanceProgramKey(program)));
    const selectedPrograms = this.getSelectedBalanceProgramEntries(query);
    const selectedIds = new Set(selectedPrograms.map((program) => getBalanceProgramKey(program)));
    const groups = new Map([
      ['CREDIT_CARD', { label: 'Cards', items: [], pendingItems: [] }],
      ['AIRLINE', { label: 'Airlines', items: [], pendingItems: [] }],
      ['HOTEL', { label: 'Hotels', items: [], pendingItems: [] }],
      ['DEFAULT', { label: 'Programs', items: [], pendingItems: [] }],
    ]);

    if (activeOwnedMap.size > 0) {
      const ownedWrap = document.createElement('div');
      ownedWrap.className = 'px-3.5 pb-3';

      const ownedLabel = document.createElement('p');
      ownedLabel.className = 'pb-2 text-[11px] font-medium uppercase tracking-[0.08em] text-gray-400';
      ownedLabel.textContent = 'Already added';
      ownedWrap.appendChild(ownedLabel);

      const ownedPills = document.createElement('div');
      ownedPills.className = 'flex flex-wrap gap-2';
      activeOwnedMap.forEach((program) => {
        ownedPills.appendChild(makePill({
          label: program.name,
          iconUrl: program.logo_url,
          iconAlt: program.full_name || program.name,
          selected: true,
          onClick: () => this.togglePendingDeleteProgram(program),
        }));
      });
      ownedWrap.appendChild(ownedPills);
      container.appendChild(ownedWrap);
    }

    sourcePrograms.forEach((program) => {
      const category = groups.get(program.category || 'CREDIT_CARD') || groups.get('CREDIT_CARD');
      category.items.push(program);
    });

    pendingDeleteMap.forEach((program) => {
      const category = groups.get(program.category || 'CREDIT_CARD') || groups.get('CREDIT_CARD');
      category.pendingItems.push(program);
    });

    groups.forEach((group) => {
      if (!group.items.length && !group.pendingItems.length) return;

      const groupWrap = document.createElement('div');
      groupWrap.className = 'px-3.5 pb-3';

      const groupLabel = document.createElement('p');
      groupLabel.className = 'pb-2 text-[11px] font-medium uppercase tracking-[0.08em] text-gray-400';
      groupLabel.textContent = group.label;
      groupWrap.appendChild(groupLabel);

      const pills = document.createElement('div');
      pills.className = 'flex flex-wrap gap-2';
      group.pendingItems.forEach((program) => {
        pills.appendChild(makePill({
          label: program.name,
          iconUrl: program.logo_url,
          iconAlt: program.full_name || program.name,
          onClick: () => this.togglePendingDeleteProgram(program),
        }));
      });
      group.items.forEach((program) => {
        pills.appendChild(makePill({
          label: program.name,
          iconUrl: program.logo_url,
          iconAlt: program.full_name || program.name,
          selected: selectedIds.has(getBalanceProgramKey(program)),
          onClick: () => this.toggleBalanceProgram(program),
        }));
      });
      groupWrap.appendChild(pills);
      container.appendChild(groupWrap);
    });
  }

  renderPendingDeletePreview() {
    if (!this.livePreview || !this.previewSummary || !this.previewEffects) return;
    const pendingPrograms = (this.programs || []).filter((p) => this.pendingDeleteKeys.has(getBalanceProgramKey(p)));
    if (!pendingPrograms.length) return;

    this.hideError();
    this.hideResolution();
    this.clearPreviewSuggestions();
    this.livePreview.classList.add('kay-preview-visible');
    if (this.previewInterpretation) {
      this.previewInterpretation.textContent = '';
      this.previewInterpretation.classList.add('hidden');
    }

    this.previewSummary.textContent = pendingPrograms.length === 1
      ? `Remove ${pendingPrograms[0].name} from your portfolio`
      : `Remove ${pendingPrograms.length} programs from your portfolio`;

    if (this.previewHint) {
      this.previewHint.textContent = 'Press Enter to confirm';
      this.previewHint.classList.remove('hidden');
    }

    this.previewEffects.innerHTML = '';
    pendingPrograms.forEach((program, i) => this.appendBalanceRemovalRow(program, i));
  }

  appendPendingDeleteRows(pendingPrograms) {
    if (!this.previewEffects || !this.previewSummary) return;
    const removeCount = pendingPrograms.length;
    if (!removeCount) return;

    const offset = this.previewEffects.children.length;
    pendingPrograms.forEach((program, i) => this.appendBalanceRemovalRow(program, offset + i));

    const current = (this.previewSummary.textContent || '').trim();
    const removeText = `remove ${removeCount} program${removeCount === 1 ? '' : 's'}`;
    this.previewSummary.textContent = current ? `${current}, ${removeText}` : `Remove ${removeCount} program${removeCount === 1 ? '' : 's'}`;
  }

  appendBalanceRemovalRow(program, index = 0) {
    if (!this.previewEffects) return;
    const row = document.createElement('div');
    row.className = 'kay-preview-row flex items-center justify-between gap-3 px-4 py-3';
    row.style.animationDelay = `${index * 40}ms`;

    const labelWrap = document.createElement('div');
    labelWrap.className = 'flex min-w-0 items-center gap-3';

    if (program.logo_url) {
      const logo = document.createElement('img');
      logo.src = program.logo_url;
      logo.alt = program.full_name || program.name;
      logo.className = 'kay-program-logo shrink-0';
      logo.addEventListener('error', () => logo.remove(), { once: true });
      labelWrap.appendChild(logo);
    }

    const label = document.createElement('div');
    label.className = 'truncate text-sm text-gray-700';
    label.textContent = program.name;
    labelWrap.appendChild(label);

    const value = document.createElement('div');
    value.className = 'text-xs text-gray-500 text-right';
    value.textContent = 'Will be removed';

    row.appendChild(labelWrap);
    row.appendChild(value);
    this.previewEffects.appendChild(row);
  }

  filterBalancePrograms(searchTerms) {
    const programs = Array.isArray(this.availablePrograms) ? this.availablePrograms : [];
    if (!searchTerms.length) return programs;

    const scoreProgram = (program) => {
      const haystack = [
        ...buildProgramAliases(program),
      ].map((value) => String(value).toLowerCase());

      let score = 0;
      searchTerms.forEach((term) => {
        haystack.forEach((value) => {
          if (value === term) score += 12;
          else if (value.startsWith(term)) score += 8;
          else if (value.includes(term)) score += 5;
          else if (term.includes(value) && value.length >= 3) score += 2;
        });
      });

      return score;
    };

    const ranked = programs
      .map((program) => ({ program, score: scoreProgram(program) }))
      .filter(({ score }) => score > 0)
      .sort((a, b) => b.score - a.score || a.program.name.localeCompare(b.program.name));

    return ranked.length ? ranked.map(({ program }) => program) : programs;
  }

  getFlightContextState() {
    if (typeof window.getCommandCenterFlightContextState !== 'function') {
      return null;
    }

    try {
      const context = window.getCommandCenterFlightContextState();
      if (!context || !context.page) return null;
      return context;
    } catch (error) {
      console.error('[Kay] failed to read flight context state', error);
      return null;
    }
  }

  getContextAirportDisplay(codes, options = []) {
    const normalizedCodes = Array.isArray(codes)
      ? codes.map((code) => String(code || '').trim().toUpperCase()).filter(Boolean)
      : [];
    if (!normalizedCodes.length) return '';
    const byCode = new Map((options || []).map((option) => [String(option.code || '').trim().toUpperCase(), option]));
    if (normalizedCodes.length === 1) {
      const option = byCode.get(normalizedCodes[0]);
      if (option?.city) return `${option.city} (${normalizedCodes[0]})`;
      if (option?.name) return `${option.name} (${normalizedCodes[0]})`;
      return normalizedCodes[0];
    }

    const labels = normalizedCodes
      .map((code) => byCode.get(code))
      .filter(Boolean)
      .map((option) => option.city || option.name || option.code);
    const uniqueLabels = [...new Set(labels)];
    if (uniqueLabels.length === 1) {
      return `${uniqueLabels[0]} (${normalizedCodes.join(', ')})`;
    }
    return normalizedCodes.join(', ');
  }

  resolveContextAirportCodes(rawText, options = [], { allowBroad = true } = {}) {
    const normalized = normalizeContextValue(rawText);
    if (!normalized) return [];

    const normalizedOptions = Array.isArray(options) ? options : [];
    const exactCodeMatches = normalizedOptions.filter((option) => (
      normalizeContextValue(option.code) === normalized
    ));
    if (exactCodeMatches.length) {
      return exactCodeMatches.map((option) => option.code);
    }

    const candidateOptions = normalizedOptions.length
      ? normalizedOptions
      : (/^[a-z]{3,5}$/i.test(normalized) ? [{ code: normalized.toUpperCase(), city: '', name: '' }] : []);
    if (!candidateOptions.length) return [];

    const getOptionTerms = (option) => (
      [option.code, option.city, option.name]
        .map(normalizeContextValue)
        .filter(Boolean)
    );

    const exactMatches = candidateOptions.filter((option) => getOptionTerms(option).includes(normalized));
    const fuzzyMatches = exactMatches.length
      ? exactMatches
      : candidateOptions.filter((option) => (
        getOptionTerms(option).some((term) => (
          term.startsWith(normalized) ||
          normalized.startsWith(term) ||
          (normalized.length >= 3 && term.includes(normalized))
        ))
      ));

    if (!fuzzyMatches.length) {
      return [];
    }

    const uniqueMatches = [...new Map(
      fuzzyMatches.map((option) => [String(option.code || '').trim().toUpperCase(), option]),
    ).values()];

    const multiCityMatches = uniqueMatches.filter((option) => option.is_multi_city);
    if (multiCityMatches.length) {
      return multiCityMatches.map((option) => option.code);
    }

    const primaryMatches = uniqueMatches.filter((option) => option.is_primary);
    if (primaryMatches.length) {
      return [primaryMatches[0].code];
    }

    if (uniqueMatches.length === 1 || !allowBroad) {
      return [uniqueMatches[0].code];
    }

    return uniqueMatches.map((option) => option.code);
  }

  resolveContextAirlineMatches(rawText, context) {
    const normalizedParts = splitContextList(rawText).map(normalizeContextValue).filter(Boolean);
    const airlines = Array.isArray(context?.airlines) ? context.airlines : [];
    if (!normalizedParts.length || !airlines.length) {
      return [];
    }

    const matched = [];
    const seenCodes = new Set();
    for (const part of normalizedParts) {
      const exactMatches = airlines.filter((airline) => (
        part === normalizeContextValue(airline.name) ||
        part === normalizeContextValue(airline.code)
      ));
      if (!exactMatches.length) {
        return [];
      }
      const picked = exactMatches[0];
      const code = String(picked.code || '').trim().toUpperCase();
      if (code && !seenCodes.has(code)) {
        seenCodes.add(code);
        matched.push(picked);
      }
    }

    return matched;
  }

  resolveContextProgramMatches(rawText, programs = [], { excludeCreditCard = false } = {}) {
    const scopeParts = splitContextList(String(rawText || '').replace(/\bonly\b/gi, ' '));
    if (!scopeParts.length) {
      return [];
    }

    const matchedPrograms = [];
    const seenKeys = new Set();

    const pickCandidate = (token, candidates) => {
      const sorted = [...candidates].sort((a, b) => {
        const aDirectName = normalizeBalanceToken(a.name) === token || normalizeBalanceToken(a.full_name) === token ? 1 : 0;
        const bDirectName = normalizeBalanceToken(b.name) === token || normalizeBalanceToken(b.full_name) === token ? 1 : 0;
        if (bDirectName !== aDirectName) return bDirectName - aDirectName;
        return String(a.name || '').localeCompare(String(b.name || ''));
      });
      return sorted[0] || null;
    };

    for (const part of scopeParts) {
      const parsed = parseUsingScopeValue(part);
      const token = normalizeBalanceToken(parsed?.program || part);
      if (!token) return [];

      const candidates = programs.filter((program) => {
        if (excludeCreditCard && String(program.category || '').toUpperCase() === 'CREDIT_CARD') {
          return false;
        }
        return buildProgramAliases(program).some((alias) => alias === token);
      });

      if (!candidates.length) {
        return [];
      }

      const picked = pickCandidate(token, candidates);
      if (!picked) {
        return [];
      }

      const uniqueKey = String(picked.id || picked.name || picked.full_name || token);
      if (!seenKeys.has(uniqueKey)) {
        seenKeys.add(uniqueKey);
        matchedPrograms.push({
          ...picked,
          amount: parsed?.amount ? parsed.amount.replace(/,/g, '') : '',
        });
      } else if (parsed?.amount) {
        const existing = matchedPrograms.find((program) => String(program.id || program.name) === uniqueKey);
        if (existing && !existing.amount) {
          existing.amount = parsed.amount.replace(/,/g, '');
        }
      }
    }

    return matchedPrograms;
  }

  buildContextualBalancesParam(selectedPrograms) {
    const ownedPrograms = Array.isArray(this.programs) ? this.programs : [];
    if (!ownedPrograms.length || !selectedPrograms.length) {
      return '';
    }

    const selectedById = new Map(
      selectedPrograms.map((program) => [String(program.id), program]),
    );

    return ownedPrograms.map((program) => {
      const key = String(program.id);
      const selected = selectedById.get(key);
      if (!selected) {
        return `${key}:0`;
      }

      const explicitAmount = parseInt(String(selected.amount || '').replace(/,/g, ''), 10);
      const currentBalance = parseInt(program.balance, 10) || 0;
      const effectiveBalance = Number.isFinite(explicitAmount) ? explicitAmount : currentBalance;
      return `${key}:${effectiveBalance}`;
    }).join(',');
  }

  buildContextualFlightAction(rawQuery) {
    const context = this.getFlightContextState();
    if (!context) {
      return null;
    }

    const query = String(rawQuery || '').trim();
    const normalizedQuery = query.toLowerCase();
    if (!query) return null;

    if (
      isHelpQuery(normalizedQuery) ||
      isBalanceEntryPrompt(normalizedQuery) ||
      isTransferQuery(normalizedQuery) ||
      UPDATE_SET_BALANCE_QUERY_RE.test(normalizedQuery) ||
      getNavigationMatch(normalizedQuery) ||
      BILLING_QUERY_RE.test(normalizedQuery) ||
      REFERRAL_QUERY_RE.test(normalizedQuery) ||
      FREE_TRIAL_QUERY_RE.test(normalizedQuery) ||
      UPGRADE_QUERY_RE.test(normalizedQuery) ||
      (/^(?:delete|remove|clear)\b/.test(normalizedQuery) && !/\bclass\b/.test(normalizedQuery))
    ) {
      return null;
    }

    const isResetFiltersQuery = CONTEXT_RESET_FILTERS_RE.test(query);
    if (isResetFiltersQuery) {
      const baseUrl = new URL(
        context.page === 'results' ? (context.currentUrl || context.explorerUrl) : (context.currentUrl || context.explorerUrl),
        window.location.origin,
      );
      const params = baseUrl.searchParams;

      if (context.page === 'results') {
        ['cabin', 'stops', 'canbook', 'balances', 'programs', 'programs_mode', 'results_airline', 'results_card', 'results_alliance', 'sort', 'passengers', 'airlines'].forEach((key) => params.delete(key));
      } else {
        ['origins', 'destinations', 'cabin', 'stops', 'airlines', 'programs', 'programs_mode', 'canbook', 'region', 'miles_min', 'miles_max', 'date_from', 'date_to', 'balances', 'international', 'freshness', 'passengers'].forEach((key) => params.delete(key));
      }

      return {
        label: 'Reset Filters',
        url: baseUrl.toString(),
        summary: 'Reset flight filters.',
        previewData: {
          status: 'ok',
          summary: 'Reset current flight filters.',
          details_preview: [],
          effects_preview: [],
          hint: getExecuteHint('apply'),
        },
      };
    }

    const routePatternCandidate = normalizeRouteDateText(
      stripCabinPhrases(stripConversationalPrefixes(query))
        .replace(/\b(?:i can book|can book)\b/gi, ' ')
        .replace(/\bonly\b/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim(),
    );

    const cabinValues = parseContextCabinValues(query);
    const passengerCount = parseContextPassengerCount(query);
    const canBookRequested = /\b(?:i can book|can book)\b/i.test(query);
    const sortValue = context.page === 'results' ? parseContextSortValue(query) : '';

    let routeQuery = parseRouteShorthandQuery(routePatternCandidate);
    if (routeQuery?.date) {
      routeQuery = null;
    }

    let originText = routeQuery?.origin || '';
    let destinationText = routeQuery?.destination || '';
    let scopeText = routeQuery?.programText
      ? `${routeQuery.programText}${routeQuery.balanceText ? ` ${routeQuery.balanceText}` : ''}`
      : '';
    let regionKeys = [];

    const parsePartialPlace = (value) => {
      let placeValue = String(value || '').trim();
      let scopedValue = '';
      let passengers = 0;

      const usingMatch = placeValue.match(/^(?<place>.+?)\s+(?:using(?:\s+my)?|with)\s+(?<scope>.+)$/i);
      if (usingMatch?.groups?.place && usingMatch?.groups?.scope) {
        placeValue = usingMatch.groups.place.trim();
        const scoped = splitTrailingDateConstraint(usingMatch.groups.scope.trim());
        if (scoped.date) return null;
        scopedValue = scoped.value.trim();
        passengers = scoped.passengers || 0;
      } else {
        const inMatch = placeValue.match(/^(?<place>.+?)\s+in\s+(?<scope>.+)$/i);
        if (inMatch?.groups?.place && inMatch?.groups?.scope && !looksLikeDateConstraint(inMatch.groups.scope.trim())) {
          placeValue = inMatch.groups.place.trim();
          const scoped = splitTrailingDateConstraint(inMatch.groups.scope.trim());
          if (scoped.date) return null;
          scopedValue = scoped.value.trim();
          passengers = scoped.passengers || 0;
        } else {
          const trailing = splitTrailingDateConstraint(placeValue);
          if (trailing.date) return null;
          placeValue = trailing.value.trim();
          passengers = trailing.passengers || 0;
        }
      }

      return {
        place: placeValue.trim(),
        scopeText: scopedValue,
        passengers,
      };
    };

    if (!routeQuery) {
      const normalizedFragment = routePatternCandidate
        .replace(/^(?:find\s+me\s+|search\s+)?(?:award\s+)?/i, '')
        .trim();
      const fromMatch = normalizedFragment.match(/^(?:flights?\s+)?from\s+(?<body>.+)$/i);
      const toMatch = normalizedFragment.match(/^(?:flights?\s+)?to\s+(?<body>.+)$/i);
      if (fromMatch?.groups?.body && !/\bto\b/i.test(fromMatch.groups.body)) {
        const parsed = parsePartialPlace(fromMatch.groups.body);
        if (parsed?.place) {
          originText = parsed.place;
          if (!scopeText && parsed.scopeText) scopeText = parsed.scopeText;
        }
      } else if (toMatch?.groups?.body && !/\bfrom\b/i.test(toMatch.groups.body)) {
        const parsed = parsePartialPlace(toMatch.groups.body);
        if (parsed?.place) {
          destinationText = parsed.place;
          if (!scopeText && parsed.scopeText) scopeText = parsed.scopeText;
        }
      }
    }

    const scopeOnlyMatch = query.match(CONTEXT_SCOPE_PREFIX_RE);
    if (scopeOnlyMatch?.groups?.scope) {
      scopeText = scopeOnlyMatch.groups.scope.trim();
    }

    const airlinesOnlyMatch = !scopeText ? query.match(CONTEXT_AIRLINES_ONLY_RE) : null;
    if (airlinesOnlyMatch?.groups?.scope) {
      scopeText = airlinesOnlyMatch.groups.scope.trim();
    }

    if (destinationText) {
      regionKeys = resolveContextRegionKeys(destinationText);
    }

    const hasRouteIntent = Boolean(routeQuery || originText || destinationText || CONTEXT_ROUTE_COMMAND_RE.test(query));
    const hasContextualChange = Boolean(
      originText ||
      destinationText ||
      scopeText ||
      cabinValues.length ||
      passengerCount ||
      canBookRequested ||
      sortValue ||
      regionKeys.length
    );
    if (!hasContextualChange) {
      return null;
    }

    const shouldUseExplorerBase = context.page === 'results' && (
      Boolean(originText) ||
      Boolean(destinationText) ||
      Boolean(regionKeys.length) ||
      (scopeText && this.resolveContextAirlineMatches(scopeText, context).length > 1) ||
      cabinValues.length > 1
    );

    const baseUrl = new URL(
      shouldUseExplorerBase ? (context.explorerUrl || context.currentUrl) : (context.currentUrl || context.explorerUrl),
      window.location.origin,
    );
    const params = baseUrl.searchParams;
    const originOptions = context.airports?.origins || [];
    const destinationOptions = context.airports?.destinations || [];

    const clearScopeParams = () => {
      ['canbook', 'balances', 'programs', 'programs_mode', 'airlines', 'results_airline', 'results_card', 'results_alliance'].forEach((key) => params.delete(key));
    };

    const details = [];

    if (originText) {
      const originCodes = this.resolveContextAirportCodes(originText, originOptions, { allowBroad: context.page === 'explorer' });
      if (!originCodes.length) return null;
      params.set('origins', originCodes.join(','));
      details.push({
        label: 'Origin',
        value: this.getContextAirportDisplay(originCodes, originOptions),
      });
    }

    if (destinationText) {
      if (regionKeys.length) {
        params.delete('destinations');
        params.set('region', regionKeys.join(','));
        details.push({
          label: 'Region',
          value: regionKeys.map(formatContextRegionLabel).join(', '),
        });
      } else {
        const destinationCodes = this.resolveContextAirportCodes(destinationText, destinationOptions, { allowBroad: true });
        if (!destinationCodes.length) return null;
        params.delete('region');
        params.set('destinations', destinationCodes.join(','));
        details.push({
          label: 'Destination',
          value: this.getContextAirportDisplay(destinationCodes, destinationOptions),
        });
      }
    }

    if (scopeText) {
      const matchedAirlines = this.resolveContextAirlineMatches(scopeText, context);
      if (matchedAirlines.length) {
        clearScopeParams();
        if (context.page === 'results' && !shouldUseExplorerBase && matchedAirlines.length === 1) {
          params.set('results_airline', String(matchedAirlines[0].code || '').trim().toUpperCase());
        } else {
          params.set('airlines', matchedAirlines.map((airline) => String(airline.code || '').trim().toUpperCase()).join(','));
        }
        details.push({
          label: 'Airlines',
          value: matchedAirlines.map((airline) => airline.name || airline.code).join(', '),
        });
      } else {
        const ownedProgramMatches = this.resolveContextProgramMatches(scopeText, this.programs);
        if (ownedProgramMatches.length) {
          clearScopeParams();
          params.set('canbook', 'yes');
          params.set('balances', this.buildContextualBalancesParam(ownedProgramMatches));
          details.push({
            label: 'Programs',
            value: ownedProgramMatches.map((program) => program.name).join(', '),
          });
        } else {
          const resultProgramMatches = this.resolveContextProgramMatches(scopeText, this.availablePrograms, { excludeCreditCard: true });
          if (!resultProgramMatches.length) {
            return null;
          }
          clearScopeParams();
          params.set('programs', resultProgramMatches.map((program) => String(program.id)).join(','));
          params.set('programs_mode', 'include');
          details.push({
            label: 'Programs',
            value: resultProgramMatches.map((program) => program.name).join(', '),
          });
        }
      }
    }

    if (cabinValues.length) {
      params.set('cabin', cabinValues.join(','));
      details.push({
        label: 'Cabin',
        value: cabinValues.map(formatCabinValue).join(', '),
      });
    }

    if (passengerCount) {
      if (passengerCount > 1) {
        params.set('passengers', String(passengerCount));
      } else {
        params.delete('passengers');
      }
      details.push({
        label: 'Passengers',
        value: String(passengerCount),
      });
    }

    if (canBookRequested) {
      params.set('canbook', 'yes');
      if (!details.some((detail) => detail.label === 'Booking')) {
        details.push({
          label: 'Booking',
          value: 'Can book',
        });
      }
    }

    if (sortValue && context.page === 'results' && !shouldUseExplorerBase) {
      params.set('sort', sortValue);
      details.push({
        label: 'Sort',
        value: sortValue.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()),
      });
    }

    if (!details.length && hasRouteIntent) {
      return null;
    }

    const summary = shouldUseExplorerBase
      ? 'Opened Flight Explorer with updated filters.'
      : 'Applied flight filters.';

    return {
      label: 'Apply Filters',
      url: baseUrl.toString(),
      summary,
      previewData: {
        status: 'ok',
        summary: shouldUseExplorerBase
          ? 'Open Flight Explorer with these filters.'
          : 'Apply these filters on the current page.',
        details_preview: details,
        effects_preview: [],
        hint: getExecuteHint('apply'),
      },
    };
  }

  insertBalanceProgram(program) {
    const programName = String(program?.name || program?.full_name || '').trim();
    if (!programName) return;
    const current = this.input.value;
    const query = current.trim().toLowerCase();
    const prefix = getBalanceEntryPrefix(current);
    const entries = this.getSelectedBalanceProgramEntries(query);

    const parts = entries.map((entry) => {
      if (entry.amount) return `${entry.name} ${entry.amount}`;
      return entry.name;
    });
    parts.push(programName);

    this.fillAndFocus(`${prefix}${parts.join(', ')}, `);
  }

  removeBalanceProgram(program) {
    const programKey = getBalanceProgramKey(program);
    if (!programKey) return;
    const current = this.input.value;
    if (!isBalanceEntryPrompt(current)) return;

    const query = current.trim().toLowerCase();
    const prefix = getBalanceEntryPrefix(current);
    const entries = this.getSelectedBalanceProgramEntries(query);
    const remaining = entries.filter((entry) => getBalanceProgramKey(entry) !== programKey);

    if (!remaining.length) {
      this.fillAndFocus(prefix);
      return;
    }

    const parts = remaining.map((entry) => {
      if (entry.amount) return `${entry.name} ${entry.amount}`;
      return entry.name;
    });
    this.fillAndFocus(`${prefix}${parts.join(', ')}, `);
  }

  togglePendingDeleteProgram(program) {
    const key = getBalanceProgramKey(program);
    if (!key) return;
    if (this.pendingDeleteKeys.has(key)) {
      this.pendingDeleteKeys.delete(key);
    } else {
      this.pendingDeleteKeys.add(key);
    }
    this.renderSuggestions();
    this.applySettledInputState();
  }

  toggleBalanceProgram(program) {
    const query = this.input.value.trim().toLowerCase();
    const selectedPrograms = this.getSelectedBalancePrograms(query);
    const programKey = getBalanceProgramKey(program);
    const isSelected = selectedPrograms.some((selectedProgram) => getBalanceProgramKey(selectedProgram) === programKey);
    if (isSelected) {
      this.removeBalanceProgram(program);
      return;
    }
    this.insertBalanceProgram(program);
  }

  getSelectedBalanceProgramEntries(query) {
    if (!isBalanceEntryPrompt(query || '')) return [];
    const remainder = normalizeBalanceQueryText(getBalanceEntryRemainder(query));
    if (!remainder) return [];

    const programs = Array.isArray(this.availablePrograms) ? this.availablePrograms : [];
    const aliasEntries = [];

    programs.forEach((program) => {
      const uniqueAliases = buildProgramAliases(program);
      uniqueAliases.forEach((alias) => {
        aliasEntries.push({
          program,
          alias,
          aliasLength: alias.length,
        });
      });
    });

    const matches = [];
    aliasEntries.forEach(({ program, alias, aliasLength }) => {
      const pattern = new RegExp(`(^|[\\s,])${escapeRegExp(alias)}(?=[\\s,]|$)`, 'ig');
      let match;
      while ((match = pattern.exec(remainder)) !== null) {
        const boundaryLength = match[1] ? match[1].length : 0;
        const start = match.index + boundaryLength;
        const end = start + alias.length;
        matches.push({
          program,
          alias,
          aliasLength,
          start,
          end,
        });
        if (pattern.lastIndex === match.index) {
          pattern.lastIndex += 1;
        }
      }
    });

    matches.sort((a, b) => {
      if (b.aliasLength !== a.aliasLength) return b.aliasLength - a.aliasLength;
      if (a.start !== b.start) return a.start - b.start;
      return (a.program.name || '').localeCompare(b.program.name || '');
    });

    const chosen = [];
    const seenPrograms = new Set();
    matches.forEach((match) => {
      const programKey = getBalanceProgramKey(match.program);
      if (seenPrograms.has(programKey)) return;
      const overlaps = chosen.some((selected) => !(match.end <= selected.start || match.start >= selected.end));
      if (overlaps) return;
      seenPrograms.add(programKey);
      chosen.push(match);
    });

    chosen.sort((a, b) => a.start - b.start || b.aliasLength - a.aliasLength);

    const selected = chosen.map((match) => ({
      ...match.program,
      amount: '',
      _start: match.start,
      _end: match.end,
    }));

    if (!selected.length) return [];

    const leadingAmount = extractBalanceGapAmount(remainder.slice(0, selected[0]._start));
    if (leadingAmount) {
      selected[0].amount = leadingAmount;
    }

    selected.forEach((program, index) => {
      const nextProgram = selected[index + 1];
      if (!nextProgram) return;

      const gapAmount = extractBalanceGapAmount(remainder.slice(program._end, nextProgram._start));
      if (!gapAmount) return;

      if (!program.amount) {
        program.amount = gapAmount;
        return;
      }

      if (!nextProgram.amount) {
        nextProgram.amount = gapAmount;
      }
    });

    const lastProgram = selected[selected.length - 1];
    const trailingAmount = extractBalanceGapAmount(remainder.slice(lastProgram._end));
    if (trailingAmount && !lastProgram.amount) {
      lastProgram.amount = trailingAmount;
    }

    return selected;
  }

  getSelectedBalancePrograms(query) {
    return this.getSelectedBalanceProgramEntries(query).map((program) => {
      const { amount, _start, _end, ...programMeta } = program;
      return programMeta;
    });
  }

  captureSuggestionItems() {
    if (!this.suggestionsContainer) return;
    const resolutionItems = this.resolution?.classList.contains('hidden')
      ? []
      : Array.from(this.resolutionOptions.querySelectorAll('button[data-kay-nav-item="true"]'));
    const suggestionItems = Array.from(this.suggestionsContainer.querySelectorAll('button.kay-row, button[data-kay-nav-item="true"]'));
    this.suggestionItems = resolutionItems.concat(suggestionItems);
  }

  resetSuggestionSelection() {
    this.suggestionItems.forEach((item) => item.classList.remove('kay-row-active'));
    this.suggestionItems = [];
    this.activeSuggestionIndex = -1;
    this.keyboardSelectionActive = false;
  }

  setActiveSuggestion(index, { keyboard = false } = {}) {
    if (!this.suggestionItems.length) return;
    const clampedIndex = Math.max(0, Math.min(index, this.suggestionItems.length - 1));
    this.suggestionItems.forEach((item, itemIndex) => {
      item.classList.toggle('kay-row-active', itemIndex === clampedIndex);
    });
    this.activeSuggestionIndex = clampedIndex;
    this.keyboardSelectionActive = keyboard;
    this.suggestionItems[clampedIndex].scrollIntoView({ block: 'nearest' });
  }

  moveSuggestionSelection(delta) {
    if (!this.suggestionItems.length) return;
    if (this.activeSuggestionIndex === -1) {
      this.setActiveSuggestion(delta > 0 ? 0 : this.suggestionItems.length - 1, { keyboard: true });
      return;
    }
    const nextIndex = (this.activeSuggestionIndex + delta + this.suggestionItems.length) % this.suggestionItems.length;
    this.setActiveSuggestion(nextIndex, { keyboard: true });
  }

  shouldUseSuggestionKeyboardNav() {
    return this.suggestionItems.length > 0;
  }

  tryApplyNavigationInPlace(url, { summary = '' } = {}) {
    if (!url || typeof window.applyCommandCenterNavigationInPlace !== 'function') {
      return false;
    }

    try {
      const applied = window.applyCommandCenterNavigationInPlace(url);
      if (!applied) {
        return false;
      }
      this.close();
      if (summary) {
        showToast(summary, 'success');
      }
      return true;
    } catch (error) {
      console.error('[Kay] failed to apply in-place navigation', error);
      return false;
    }
  }

  tryApplyDashboardExploreHtmxNavigation(url, { summary = '' } = {}) {
    if (!url || typeof window.htmx === 'undefined') {
      return false;
    }

    const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
    const nextPath = new URL(url, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    const dashboardPath = '/dashboard';
    const explorePath = '/dashboard/explore';
    const onDashboardOrExplore = currentPath === dashboardPath || currentPath === explorePath;
    const isDashboardOrExploreTarget = nextPath === dashboardPath || nextPath === explorePath;

    if (!onDashboardOrExplore || !isDashboardOrExploreTarget) {
      return false;
    }

    const navLink = document.querySelector(
      `a[hx-target="#main-content"][hx-get="${nextPath}/"], a[hx-target="#main-content"][hx-get="${nextPath}"]`
    );

    if (!navLink) {
      return false;
    }

    this.close();
    navLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    if (summary) {
      setTimeout(() => showToast(summary, 'success'), 50);
    }
    return true;
  }

  navigateTo(url, { summary = '' } = {}) {
    if (!url) return;
    let parsedUrl;
    try {
      parsedUrl = new URL(url, window.location.origin);
    } catch (error) {
      parsedUrl = null;
    }
    if (parsedUrl && parsedUrl.origin !== window.location.origin) {
      this.close();
      window.open(parsedUrl.toString(), '_blank', 'noopener');
      if (summary) {
        setTimeout(() => showToast(summary, 'success'), 50);
      }
      return;
    }
    if (this.tryApplyNavigationInPlace(url, { summary })) {
      return;
    }
    if (this.tryApplyDashboardExploreHtmxNavigation(url, { summary })) {
      return;
    }
    this.close();
    window.location.assign(url);
  }

  findProgramMeta(text) {
    const query = (text || '').trim().toLowerCase();
    if (!query) return null;

    const pool = [...this.programs, ...this.availablePrograms];
    return pool.find((program) => {
      const terms = [program.name, program.full_name, program.brand_name, ...(program.search_keywords || [])]
        .filter(Boolean)
        .map((value) => value.toLowerCase());
      return terms.some((term) => query.includes(term) || term.includes(query));
    }) || null;
  }

  getPreviewSuggestedRows(query) {
    if (!this.previewSuggestedActions.length || this.previewSuggestedInput !== query) {
      return [];
    }

    return this.previewSuggestedActions.map((action) => makeRow({
      icon: this.getSuggestedActionIcon(action),
      label: action.label,
      sub: action.sub,
      iconUrl: action.icon_url,
      iconAlt: action.label,
      fillCommand: action.command || '',
      onClick: () => this.executeSuggestedAction(action),
    }));
  }

  getSuggestedActionIcon(action) {
    switch (action?.kind) {
      case 'transfer_destination':
      case 'transfer_source':
      case 'transfer_pair':
        return TRANSFER_ICON;
      case 'navigation':
        return getNavigationConfig(action?.target || action?.meta?.navigation_target)?.icon || NAV_ICON;
      default:
        return SEARCH_ICON;
    }
  }

  executeSuggestedAction(action) {
    if (!action) return;
    if (String(action.kind || '').startsWith('transfer_') && action.command) {
      this.fillAndFocus(action.command);
      return;
    }
    if (action.command) {
      this.fillAndSubmit(action.command);
      return;
    }
    if (action.navigate_to) {
      this.navigateTo(action.navigate_to);
    }
  }

  buildQuickActions() {
    const actions = [];
    const progs = this.programs;
    const routes = this.routes;

    if (progs.length > 0 || routes.length > 0) {
      // 1. Check a balance (first program)
      if (progs[0]) {
        actions.push(makeRow({
          icon: '?',
          label: `${progs[0].name} balance`,
          sub: progs[0].balance > 0 ? `${progs[0].balance.toLocaleString()} points` : 'Check your balance',
          iconUrl: progs[0].logo_url,
          iconAlt: progs[0].full_name || progs[0].name,
          fillCommand: `${progs[0].name} balance`,
          onClick: () => this.fillAndSubmit(`${progs[0].name} balance`),
        }));
      }

      // 2. Add points (second program, or first if only one)
      const addProg = progs[1] || progs[0];
      if (addProg) {
        actions.push(makeRow({
          icon: '+',
          label: `Add points to ${addProg.name}`,
          sub: `Currently ${addProg.balance.toLocaleString()} points`,
          iconUrl: addProg.logo_url,
          iconAlt: addProg.full_name || addProg.name,
          fillCommand: `added  points to ${addProg.name}`,
          onClick: () => this.fillAndFocus(`added  points to ${addProg.name}`),
        }));
      }

      // 3. Set balance (third program, or cycle)
      const setProg = progs[2] || progs[0];
      if (setProg) {
        actions.push(makeRow({
          icon: '=',
          label: `Set ${setProg.name} balance`,
          sub: `Currently ${setProg.balance.toLocaleString()} points`,
          iconUrl: setProg.logo_url,
          iconAlt: setProg.full_name || setProg.name,
          fillCommand: `${setProg.name} has `,
          onClick: () => this.fillAndFocus(`${setProg.name} has `),
        }));
      }

      // 4. Flight search (first saved route)
      if (routes[0]) {
        actions.push(makeRow({
          icon: PLANE_ICON,
          label: `Flights ${routes[0].origin} → ${routes[0].destination}`,
          sub: 'Search award availability',
          fillCommand: `flights from ${routes[0].origin} to ${routes[0].destination}`,
          onClick: () => this.fillAndSubmit(`flights from ${routes[0].origin} to ${routes[0].destination}`),
        }));
      }

      actions.push(makeRow({
        icon: TRANSFER_ICON,
        label: 'Transfer Points',
        sub: 'Open transfer calculator',
        onClick: () => this.navigateTo(this.urls.transfer_calculator),
      }));

      actions.push(makeRow({
        icon: CONSULTING_ICON,
        label: 'Book a Consultation',
        sub: 'Open the 1:1 consultation calendar',
        fillCommand: 'consultancy',
        onClick: () => this.fillAndSubmit('consultancy'),
      }));

      this.buildNavigationQuickActions().forEach((action) => actions.push(action));

      // 5. Explore bookable flights
      if (progs[0]) {
        actions.push(makeRow({
          icon: SEARCH_ICON,
          label: `Flights bookable with ${progs[0].name}`,
          sub: 'Open flight explorer',
          iconUrl: progs[0].logo_url,
          iconAlt: progs[0].full_name || progs[0].name,
          fillCommand: `show flights i can book using ${progs[0].name}`,
          onClick: () => this.fillAndSubmit(`show flights i can book using ${progs[0].name}`),
        }));
      }

      if (this.isPremium) {
        actions.push(makeRow({
          icon: SEARCH_ICON,
          label: 'Flight Explorer',
          sub: 'Browse flexible routes and filters',
          onClick: () => this.navigateTo(this.urls.flight_explorer),
        }));

        actions.push(makeRow({
          icon: PLANE_ICON,
          label: 'My Flights',
          sub: 'Open saved searches and results',
          onClick: () => this.navigateTo(this.urls.my_flights),
        }));
      }

      actions.push(makeRow({
        icon: BILLING_ICON,
        label: 'Manage Billing',
        sub: 'Open payment settings',
        onClick: () => this.fillAndSubmit('manage billing'),
      }));

      actions.push(makeRow({
        icon: REFERRAL_ICON,
        label: 'Refer a Friend',
        sub: 'Share your link and earn rewards',
        onClick: () => this.fillAndSubmit('refer a friend'),
      }));

      if (this.hasFreeTrialAvailable) {
        actions.push(makeRow({
          icon: SPARK_ICON,
          label: 'Claim 24h Free Access',
          sub: 'Open Refer & Earn',
          onClick: () => this.fillAndSubmit('free trial'),
        }));
      }

      if (!this.isPremium) {
        actions.push(makeRow({
          icon: SPARK_ICON,
          label: 'Upgrade to Pro',
          sub: 'Open Premium plans',
          onClick: () => this.fillAndSubmit('upgrade to pro'),
        }));
      }
    } else {
      // No user data — generic examples
      actions.push(makeRow({ icon: '=', label: 'Set a program balance', sub: 'e.g. "atlas has 10000 points"', fillCommand: 'atlas has 10000 points', onClick: () => this.fillAndFocus('atlas has 10000 points') }));
      actions.push(makeRow({ icon: '+', label: 'Add points', sub: 'e.g. "added 1000 to atlas"', fillCommand: 'added 1000 points to atlas', onClick: () => this.fillAndFocus('added 1000 points to atlas') }));
      actions.push(makeRow({ icon: PLANE_ICON, label: 'Search for flights', sub: 'e.g. "flights from DEL to ATL on 10th march"', fillCommand: 'flights from del to atl on 10th march', onClick: () => this.fillAndFocus('flights from del to atl on 10th march') }));
      actions.push(makeRow({ icon: TRANSFER_ICON, label: 'Transfer Points', sub: 'Open transfer calculator', onClick: () => this.navigateTo(this.urls.transfer_calculator) }));
      actions.push(makeRow({ icon: CONSULTING_ICON, label: 'Book a Consultation', sub: 'Open the 1:1 consultation calendar', fillCommand: 'consultancy', onClick: () => this.fillAndSubmit('consultancy') }));
      this.buildNavigationQuickActions().forEach((action) => actions.push(action));
      if (this.isPremium) {
        actions.push(makeRow({ icon: SEARCH_ICON, label: 'Flight Explorer', sub: 'Browse flexible routes and filters', onClick: () => this.navigateTo(this.urls.flight_explorer) }));
        actions.push(makeRow({ icon: PLANE_ICON, label: 'My Flights', sub: 'Open saved searches and results', onClick: () => this.navigateTo(this.urls.my_flights) }));
      } else {
        actions.push(makeRow({ icon: SEARCH_ICON, label: 'Explore bookable flights', sub: 'Find flights you can book with your points', onClick: () => this.fillAndFocus('show flights i can book') }));
      }
      actions.push(makeRow({ icon: BILLING_ICON, label: 'Manage Billing', sub: 'Open payment settings', onClick: () => this.fillAndSubmit('manage billing') }));
      actions.push(makeRow({ icon: REFERRAL_ICON, label: 'Refer a Friend', sub: 'Share your link and earn rewards', onClick: () => this.fillAndSubmit('refer a friend') }));
      if (this.hasFreeTrialAvailable) {
        actions.push(makeRow({ icon: SPARK_ICON, label: 'Claim 24h Free Access', sub: 'Open Refer & Earn', onClick: () => this.fillAndSubmit('free trial') }));
      }
      if (!this.isPremium) {
        actions.push(makeRow({ icon: SPARK_ICON, label: 'Upgrade to Pro', sub: 'Open Premium plans', onClick: () => this.fillAndSubmit('upgrade to pro') }));
      }
    }

    return actions;
  }

  buildBalanceModeQuickActions() {
    const actions = [];
    const progs = this.programs.slice(0, 4);
    progs.forEach((program) => {
      actions.push(makeRow({
        icon: '=',
        label: `Set ${program.name} balance`,
        sub: program.balance > 0 ? `Currently ${program.balance.toLocaleString()} points` : 'Add this balance',
        iconUrl: program.logo_url,
        iconAlt: program.full_name || program.name,
        fillCommand: `i have ${program.balance > 0 ? program.balance.toLocaleString() : ''} ${program.name}`.trim() + (program.balance > 0 ? '' : ' '),
        onClick: () => this.fillAndFocus(`i have ${program.balance > 0 ? program.balance.toLocaleString() : ''} ${program.name}`.trim() + (program.balance > 0 ? '' : ' ')),
      }));
    });
    if (!actions.length) {
      actions.push(makeRow({
        icon: '=',
        label: 'Add a balance',
        sub: 'Type your card and points balance',
        fillCommand: 'i have ',
        onClick: () => this.fillAndFocus('i have '),
      }));
    }
    return actions;
  }

  buildNavigationQuickActions() {
    const actions = [];
    const preferredTargets = ['dashboard', 'explore', 'hotels', 'settings', 'my_flights', 'tools', 'transfer_calculator'];
    preferredTargets.forEach((target) => {
      const config = getNavigationConfig(target);
      const url = this.urls[target];
      if (!config || !url) return;
      actions.push(makeRow({
        icon: config.icon || NAV_ICON,
        label: config.label,
        sub: config.sub,
        fillCommand: config.command,
        onClick: () => this.navigateTo(url),
      }));
    });
    return actions;
  }

  buildHelpSections(searchTerms = []) {
    const sections = HELP_SECTION_DEFINITIONS
      .filter((section) => !section.requiresUrl || Boolean(this.urls[section.requiresUrl]))
      .map((section) => ({
      ...section,
      rows: section.rows.map((row) => ({
        ...row,
        fillCommand: row.command,
        onClick: () => this.fillAndFocus(row.command),
      })),
      }));

    if (!searchTerms.length) {
      return sections;
    }

    const filteredSections = sections
      .map((section) => {
        const sectionHaystack = [section.title, ...(section.keywords || [])]
          .join(' ')
          .toLowerCase();
        const filteredRows = section.rows.filter((row) => {
          const rowHaystack = [row.label, row.sub, ...(row.keywords || [])]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
          return searchTerms.some((term) => rowHaystack.includes(term) || sectionHaystack.includes(term));
        });

        if (filteredRows.length > 0) {
          return { ...section, rows: filteredRows };
        }

        if (searchTerms.some((term) => sectionHaystack.includes(term))) {
          return section;
        }

        return null;
      })
      .filter(Boolean);

    return filteredSections.length ? filteredSections : sections;
  }

  getSuggestionsForQuery(query) {
    const items = [];
    const seenSuggestionKeys = new Set();
    const words = query.split(/\s+/);
    const hasNumber = /\d/.test(query);
    const firstAmountMatch = query.match(/[\d,]+/);
    const typedAmountText = firstAmountMatch ? firstAmountMatch[0] : '';
    const isBulkDeleteQuery = /^(?:delete|remove|clear)\s+(?:all\b|everything\b)/.test(query);
    const isTransfer = isTransferQuery(query);
    const isHotelSearch = isHotelQuery(query);

    // ── Detect intent ──
    const isBalanceQuery = ['balance', 'how many', 'check'].some((k) => query.includes(k));
    const routeQuery = parseRouteShorthandQuery(query);
    const isSetQuery = (
      ['has', '='].some((k) => query.includes(k)) && hasNumber
    ) || (
      hasNumber &&
      !routeQuery &&
      !isTransfer &&
      !isHotelSearch &&
      !isBalanceQuery &&
      !['add', 'added', 'increase'].some((k) => query.startsWith(k)) &&
      !['used', 'spent', 'subtract', 'deduct', 'remove', 'reduce', 'reduced'].some((k) => query.startsWith(k)) &&
      !query.startsWith('delete') &&
      !['flight', 'flights', 'fly', 'award', 'from', 'book'].some((k) => query.includes(k))
    );
    const isAddQuery = ['add', 'added', 'increase'].some((k) => query.startsWith(k));
    const isSubtractQuery = !isBulkDeleteQuery && ['used', 'spent', 'subtract', 'deduct', 'remove', 'reduce', 'reduced'].some((k) => query.startsWith(k)) && hasNumber;
    const isDeleteQuery = !isBulkDeleteQuery && /^(?:delete|remove)\b/.test(query) && !hasNumber;
    const isFlightQuery = !isHotelSearch && (['flight', 'flights', 'fligh', 'fly', 'award', 'from', 'book'].some((k) => query.includes(k)) || Boolean(routeQuery));
    const isBillingQuery = BILLING_QUERY_RE.test(query);
    const isReferralQuery = REFERRAL_QUERY_RE.test(query);
    const isFreeTrialQuery = FREE_TRIAL_QUERY_RE.test(query);
    const isSubscriptionQuery = SUBSCRIPTION_QUERY_RE.test(query);
    const isUpgradeQuery = UPGRADE_QUERY_RE.test(query);
    const navigationMatch = getNavigationMatch(query);
    const navigationSuggestions = getNavigationSuggestions(query);
    const isProgramQuery = isBalanceQuery || isSetQuery || isAddQuery || isSubtractQuery || isDeleteQuery;
    const balanceEntryPrompt = isBalanceEntryPrompt(query);
    const docsCommandMatch = getDocsCommandMatch(query);

    if (docsCommandMatch) {
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: DOCS_ICON,
        label: docsCommandMatch.label,
        sub: docsCommandMatch.sub,
        badge: 'new',
        onClick: () => this.navigateTo(docsUrl(docsCommandMatch.path)),
      });
    }

    // ── Find matching programs by word overlap ──
    const matchProgram = (p) => {
      const terms = [p.name, p.full_name, p.brand_name, ...(p.search_keywords || [])]
        .filter(Boolean)
        .map((v) => v.toLowerCase());
      return terms.some((term) =>
        query.includes(term) ||
        term.includes(query) ||
        words.some((w) => w.length >= 3 && term.includes(w)),
      );
    };

    if (isProgramQuery) {
      const matched = this.programs.filter(matchProgram);
      // Use matched programs, or fall back to all if no specific match yet
      const pool = matched.length > 0 ? matched : this.programs;
      const hasSpecificProgram = matched.length > 0;

      pool.slice(0, 4).forEach((p) => {
        const pts = p.balance > 0 ? `${p.balance.toLocaleString()} points` : 'No balance set';
        if (isBalanceQuery) {
          pushUniqueSuggestion(items, seenSuggestionKeys, {
            icon: '?',
            label: `${p.name} balance`,
            sub: pts,
            iconUrl: p.logo_url,
            iconAlt: p.full_name || p.name,
            onClick: () => this.fillAndSubmit(`${p.name} balance`),
          });
        } else if (isAddQuery) {
          if (hasNumber && hasSpecificProgram) {
            const canonicalAddCommand = `add ${typedAmountText || '1000'} to ${p.name}`;
            pushUniqueSuggestion(items, seenSuggestionKeys, {
              icon: '+',
              label: `Add to ${p.name}`,
              sub: `Currently ${pts} · ${getExecuteHint('run')}`,
              iconUrl: p.logo_url,
              iconAlt: p.full_name || p.name,
              onClick: () => this.fillAndSubmit(canonicalAddCommand),
            });
          } else {
            pushUniqueSuggestion(items, seenSuggestionKeys, {
              icon: '+',
              label: `Add points to ${p.name}`,
              sub: pts,
              iconUrl: p.logo_url,
              iconAlt: p.full_name || p.name,
              onClick: () => this.fillAndFocus(`added 1000 points to ${p.name}`),
            });
          }
        } else if (isSubtractQuery) {
          if (hasNumber && hasSpecificProgram) {
            pushUniqueSuggestion(items, seenSuggestionKeys, {
              icon: '&minus;',
              label: `Deduct from ${p.name}`,
              sub: `Currently ${pts} · ${getExecuteHint('run')}`,
              iconUrl: p.logo_url,
              iconAlt: p.full_name || p.name,
              onClick: () => this.submit(),
            });
          } else {
            pushUniqueSuggestion(items, seenSuggestionKeys, {
              icon: '&minus;',
              label: `Deduct points from ${p.name}`,
              sub: pts,
              iconUrl: p.logo_url,
              iconAlt: p.full_name || p.name,
              onClick: () => this.fillAndFocus(`used 1000 from ${p.name}`),
            });
          }
        } else if (isSetQuery) {
          if (hasSpecificProgram) {
            pushUniqueSuggestion(items, seenSuggestionKeys, {
              icon: '=',
              label: `Set ${p.name} balance`,
              sub: `Currently ${pts} · ${getExecuteHint('run')}`,
              iconUrl: p.logo_url,
              iconAlt: p.full_name || p.name,
              onClick: () => this.submit(),
            });
          } else {
            pushUniqueSuggestion(items, seenSuggestionKeys, {
              icon: '=',
              label: `Set ${p.name} balance`,
              sub: `Currently ${pts}`,
              iconUrl: p.logo_url,
              iconAlt: p.full_name || p.name,
              onClick: () => this.fillAndFocus(`${p.name} has 10000 points`),
            });
          }
        } else if (isDeleteQuery) {
          pushUniqueSuggestion(items, seenSuggestionKeys, {
            icon: 'x',
            label: `Delete ${p.name}`,
            sub: 'Remove from your portfolio',
            iconUrl: p.logo_url,
            iconAlt: p.full_name || p.name,
            onClick: () => this.fillAndSubmit(`delete ${p.name}`),
          });
        }
      });
    }

    if (isBillingQuery) {
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: BILLING_ICON,
        label: 'Manage Billing',
        sub: 'Open payment settings',
        onClick: () => this.fillAndSubmit('manage billing'),
      });
    }

    if (isReferralQuery) {
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: REFERRAL_ICON,
        label: 'Refer a Friend',
        sub: 'Open your referral and rewards page',
        onClick: () => this.fillAndSubmit('refer a friend'),
      });
    }

    if (isFreeTrialQuery) {
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: SPARK_ICON,
        label: this.hasFreeTrialAvailable ? 'Claim 24h Free Access' : 'Open Refer & Earn',
        sub: this.hasFreeTrialAvailable ? 'Claim your free day pass' : 'Your day pass has already been claimed',
        onClick: () => this.fillAndSubmit('free trial'),
      });
    }

    if (!this.isPremium && (isUpgradeQuery || isSubscriptionQuery)) {
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: SPARK_ICON,
        label: 'Upgrade to Pro',
        sub: 'Open Premium plans',
        onClick: () => this.fillAndSubmit('upgrade to pro'),
      });
    }

    if (isTransfer) {
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: TRANSFER_ICON,
        label: 'Transfer Points',
        sub: getExecuteHint('open transfer options'),
        fillCommand: 'transfer points',
        onClick: () => this.fillAndSubmit('transfer points'),
      });
    }

    if (isConsultingQuery(query)) {
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: CONSULTING_ICON,
        label: 'Book a Consultation',
        sub: 'Open the 1:1 consultation calendar',
        fillCommand: 'consultancy',
        onClick: () => this.fillAndSubmit('consultancy'),
      });
    }

    if (isHotelSearch && !navigationMatch && this.urls.hotels) {
      const hasDates = HOTEL_DATE_QUERY_RE.test(query);
      pushUniqueSuggestion(items, seenSuggestionKeys, {
        icon: HOTEL_ICON,
        label: hasDates ? 'Search these hotel dates' : 'Browse these stays',
        sub: getExecuteHint(hasDates ? 'run hotel search' : 'open hotels'),
        fillCommand: query,
        onClick: () => this.submit(),
      });
    }

    if (navigationMatch && this.urls[navigationMatch.target] && !(isTransfer && navigationMatch.target === 'transfer_calculator')) {
        pushUniqueSuggestion(items, seenSuggestionKeys, {
          icon: navigationMatch.icon || NAV_ICON,
          label: navigationMatch.label,
          sub: navigationMatch.sub,
          fillCommand: navigationMatch.command,
          onClick: () => this.fillAndSubmit(navigationMatch.command),
        });
    } else {
      navigationSuggestions
        .filter((suggestion) => !(isTransfer && suggestion.target === 'transfer_calculator'))
        .slice(0, 3)
        .forEach((suggestion) => {
        if (!this.urls[suggestion.target]) return;
        pushUniqueSuggestion(items, seenSuggestionKeys, {
          icon: suggestion.icon || NAV_ICON,
          label: suggestion.label,
          sub: suggestion.sub,
          fillCommand: suggestion.command,
          onClick: () => this.fillAndFocus(suggestion.command),
        });
      });
    }

    // ── Flight suggestions ──
    if (isFlightQuery) {
      if (routeQuery) {
        const originLabel = formatRouteToken(routeQuery.origin);
        const destinationLabel = formatRouteToken(routeQuery.destination);
        const normalizedDateText = normalizeRouteDateText(routeQuery.date);
        let normalizedText = routeQuery.date
          ? `flights from ${routeQuery.origin} to ${routeQuery.destination} on ${normalizedDateText}`
          : `flights from ${routeQuery.origin} to ${routeQuery.destination}`;
        if (routeQuery.programText && routeQuery.balanceText) {
          normalizedText += ` using ${routeQuery.balanceText} ${routeQuery.programText} points`;
        } else if (routeQuery.programText) {
          normalizedText += ` using ${routeQuery.programText}`;
        }
        if (routeQuery.passengers) {
          normalizedText += ` for ${routeQuery.passengers} passenger${routeQuery.passengers === 1 ? '' : 's'}`;
        }

          pushUniqueSuggestion(items, seenSuggestionKeys, {
            icon: PLANE_ICON,
            label: `${originLabel} → ${destinationLabel}`,
            sub: routeQuery.date ? 'Search this route' : 'Add a date to search',
            badge: !this.isPremium && !routeQuery.date ? PRO_BADGE_LABEL : null,
            fillCommand: normalizedText,
            onClick: () => this.fillAndSubmit(normalizedText),
          });
        }

      this.routes.slice(0, 5).forEach((r) => {
        const text = `flights from ${r.origin} to ${r.destination}`;
        const matchesRoute = routeQuery
          ? tokenMatches(r.origin, routeQuery.origin) && tokenMatches(r.destination, routeQuery.destination)
          : (text.toLowerCase().includes(query) || query.includes(r.origin.toLowerCase()) || query.includes(r.destination.toLowerCase()));

        if (matchesRoute) {
          pushUniqueSuggestion(items, seenSuggestionKeys, {
            icon: PLANE_ICON,
            label: `${r.origin} → ${r.destination}`,
            sub: 'Search award availability',
            badge: !this.isPremium ? PRO_BADGE_LABEL : null,
            fillCommand: text,
            onClick: () => this.fillAndSubmit(text),
          });
        }
      });

      if (query.includes('from') && !query.includes(' to ')) {
        // Extract what's after "from" to filter routes by typed origin
        const afterFrom = query.split('from')[1]?.trim() || '';
        this.routes.filter((r) =>
          !afterFrom || r.origin.toLowerCase().includes(afterFrom) || afterFrom.includes(r.origin.toLowerCase())
        ).slice(0, 3).forEach((r) => {
          pushUniqueSuggestion(items, seenSuggestionKeys, {
            icon: PLANE_ICON,
            label: `${r.origin} → ${r.destination}`,
            sub: 'Add a date to search',
            badge: !this.isPremium ? PRO_BADGE_LABEL : null,
            fillCommand: `flights from ${r.origin} to ${r.destination}`,
            onClick: () => this.fillAndSubmit(`flights from ${r.origin} to ${r.destination}`),
          });
        });
      }

      if (this.programs.length > 0 && (query.includes('book') || query.includes('using'))) {
        this.programs.slice(0, 3).forEach((p) => {
          pushUniqueSuggestion(items, seenSuggestionKeys, {
            icon: SEARCH_ICON,
            label: `Bookable with ${p.name}`,
            sub: `${p.balance.toLocaleString()} points available`,
            badge: !this.isPremium ? PRO_BADGE_LABEL : null,
            iconUrl: p.logo_url,
            iconAlt: p.full_name || p.name,
            fillCommand: `show all flights i can book using ${p.name} points`,
            onClick: () => this.fillAndSubmit(`show all flights i can book using ${p.name} points`),
          });
        });
      }

      // No generic fallback — if the user typed something specific, let them press Enter
    }

    // Keep balance-entry mode focused on add/update flows, not unrelated history.
    if (balanceEntryPrompt) {
      return items.slice(0, 6);
    }

    // ── Fallback: fuzzy match history ──
    if (items.length === 0 && this.history.length > 0) {
      const matched = uniqueByDisplay(this.history, (cmd) => formatCommandSuggestionLabel(cmd)).filter((cmd) =>
        cmd.raw_input.toLowerCase().includes(query) ||
        words.some((w) => w.length >= 2 && cmd.raw_input.toLowerCase().includes(w))
      );
      matched.slice(0, 3).forEach((cmd) => {
        const matchedProgram = commandSupportsProgramLogo(cmd) ? this.findProgramMeta(cmd.raw_input) : null;
        pushUniqueSuggestion(items, seenSuggestionKeys, {
          icon: getCommandIcon(cmd),
          label: formatCommandSuggestionLabel(cmd),
          sub: cmd.summary || 'Recent command',
          iconUrl: matchedProgram?.logo_url,
          iconAlt: matchedProgram?.full_name || matchedProgram?.name || '',
          fillCommand: cmd.raw_input,
          onClick: () => this.fillAndSubmit(cmd.raw_input),
        });
      });
    }

    return items.slice(0, 6);
  }

  fillAndFocus(text) {
    this.input.value = text;
    this.handleInputChange({ immediate: true });
    this.input.focus();
    // Place cursor at the logical position (e.g. before "points to")
    const emptySpot = text.indexOf('  ');
    if (emptySpot !== -1) {
      this.input.setSelectionRange(emptySpot, emptySpot);
    }
  }

  fillAndSubmit(text) {
    this.input.value = text;
    this.handleInputChange({ immediate: true });
    this.submit();
  }

  getExecutableInput(inputValue) {
    const query = inputValue.trim();
    if (!isBalanceEntryPrompt(query)) {
      return query;
    }

    const selectedPrograms = this.getSelectedBalanceProgramEntries(query.toLowerCase());
    if (!selectedPrograms.length) {
      return query;
    }

    const ownedKeys = new Set((this.programs || []).map((program) => getBalanceProgramKey(program)));
    const clauses = [];

    selectedPrograms.forEach((program) => {
      const programName = getExecutableBalanceProgramName(program);
      if (!programName) return;
      if (program.amount) {
        clauses.push(`${programName} ${program.amount}`);
        return;
      }
      if (!ownedKeys.has(getBalanceProgramKey(program))) {
        clauses.push(`${programName} 0`);
      }
    });

    if (!clauses.length) {
      return query;
    }

    return clauses.join(', ');
  }

  // ── Submit / Success ──

  async submit(resolution = {}) {
    if (this.isSubmitting) return;

    if (
      !Object.keys(resolution || {}).length &&
      this.pendingResolution &&
      this.pendingResolution.candidates.length === 1
    ) {
      const candidate = this.pendingResolution.candidates[0];
      if (candidate?.command) {
        this.fillAndFocus(candidate.command);
        return;
      }
      if (candidate?.id && this.pendingResolution.resolution_key) {
        this.submit({ [this.pendingResolution.resolution_key]: candidate.id });
        return;
      }
    }

    const typedInputValue = this.input.value.trim();
    const inputValue = this.getExecutableInput(typedInputValue);
    if (!inputValue) {
      this.showError('Type a command first.', { fallbackToHelp: false });
      return;
    }
    if (isBalanceEntryPrompt(typedInputValue)) {
      const pendingPrograms = (this.programs || []).filter((p) => this.pendingDeleteKeys.has(getBalanceProgramKey(p)));
      const deleteNames = pendingPrograms.map((p) => getExecutableBalanceProgramName(p)).filter(Boolean);
      const deleteCommand = deleteNames.length ? `delete ${deleteNames.join(', ')}` : null;
      const addCommand = inputValue !== typedInputValue ? inputValue : null;

      // When deletes are staged, run them alongside any adds in a single Enter.
      if (deleteCommand) {
        await this.runBalanceMutations({ deleteCommand, addCommand });
        return;
      }

      // No deletes staged and nothing executable was built — guide the user.
      if (!addCommand) {
        const selectedPrograms = this.getSelectedBalancePrograms(typedInputValue.toLowerCase());
        if (selectedPrograms.length && !/\d/.test(typedInputValue)) {
          this.showError('Those programs are already in your portfolio. Add a balance to update them.', { fallbackToHelp: false });
          return;
        }
        this.showError('Select a program below to add it — e.g. i have Qantas, Velocity', { fallbackToHelp: false });
        return;
      }
      // addCommand only → fall through to the generic execute path below.
    }

    const contextualAction = this.buildContextualFlightAction(typedInputValue);
    if (contextualAction) {
      this.hideError();
      this.navigateTo(contextualAction.url, { summary: contextualAction.summary });
      return;
    }

    if (isConsultingQuery(typedInputValue)) {
      this.hideError();
      this.navigateTo(CONSULTING_URL, { summary: 'Opened consultation booking.' });
      return;
    }

    const docsCommandMatch = getDocsCommandMatch(typedInputValue);
    if (docsCommandMatch) {
      this.hideError();
      this.navigateTo(docsUrl(docsCommandMatch.path), { summary: 'Opened PointsCasa docs.' });
      return;
    }

    this.pendingInput = typedInputValue;
    this.hideError();
    this.setSubmitting(true);

    try {
      const response = await fetch(EXECUTE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': getCsrfToken(),
        },
        body: JSON.stringify({
          input: inputValue,
          resolution,
          context: {
            path: window.location.pathname,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }),
      });

      const data = await response.json();
      if (data.status === 'needs_resolution') {
        this.hideLivePreview();
        this.renderResolution(data);
        this.renderSuggestions();
        return;
      }

      if (!response.ok || data.status !== 'ok') {
        this.showError(data.summary || 'Command failed.');
        return;
      }

      // Invalidate cache so next open shows fresh history
      this.suggestionsLoaded = false;
      this.clearCachedData();
      this.handleSuccess(data);
    } catch (error) {
      console.error('[Kay] request failed', error);
      this.showError('Command failed. Check your connection and try again.', { fallbackToHelp: false });
    } finally {
      this.setSubmitting(false);
      this.focusInputAtEnd();
    }
  }

  async runBalanceMutations({ deleteCommand = null, addCommand = null } = {}) {
    const commands = [deleteCommand, addCommand].filter(Boolean);
    if (!commands.length) return;

    this.hideError();
    this.setSubmitting(true);
    const summaries = [];
    try {
      for (const command of commands) {
        const response = await fetch(EXECUTE_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCsrfToken(),
          },
          body: JSON.stringify({
            input: command,
            resolution: {},
            context: {
              path: window.location.pathname,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
          }),
        });
        const data = await response.json();
        if (!response.ok || data.status !== 'ok') {
          this.suggestionsLoaded = false;
          this.clearCachedData();
          this.showError(data.summary || 'Command failed.', { fallbackToHelp: false });
          return;
        }
        if (data.summary) summaries.push(data.summary);
      }
      this.suggestionsLoaded = false;
      this.clearCachedData();
      this.refreshProgramsTable();
      this.close();
      showToast(summaries.join('  ') || 'Done.', 'success');
    } catch (error) {
      console.error('[Kay] request failed', error);
      this.showError('Command failed. Check your connection and try again.', { fallbackToHelp: false });
    } finally {
      this.setSubmitting(false);
      this.focusInputAtEnd();
    }
  }

  handleSuccess(data) {
    if (data.action_type === 'mutation') {
      this.refreshProgramsTable();
      this.close();
      showToast(data.summary, 'success');
      return;
    }

    if (data.action_type === 'info') {
      this.close();
      showToast(data.summary, 'success');
      return;
    }

    if (data.action_type === 'upgrade') {
      this.close();
      if (typeof window.pricing_plan_modal?.showModal === 'function') {
        window.setTimeout(() => window.pricing_plan_modal.showModal(), 120);
        return;
      }
      showToast(data.summary || 'This feature requires Premium.', 'info');
      return;
    }

    if (data.action_type === 'prefill_search') {
      if (typeof window.pricing_plan_modal?.showModal === 'function') {
        this.close();
        window.setTimeout(() => window.pricing_plan_modal.showModal(), 120);
        return;
      }
      if (data.navigate_to) {
        this.navigateTo(data.navigate_to, { summary: data.summary });
        return;
      }
      showToast('This feature requires Premium.', 'info');
      return;
    }

    if (data.navigate_to) {
      if (data.open_in_new_tab) {
        this.close();
        window.open(data.navigate_to, '_blank', 'noopener');
        return;
      }
      this.navigateTo(data.navigate_to, { summary: data.summary });
      return;
    }

    showToast(data.summary || 'Command completed.', 'success');
  }

  renderResolution(data) {
    this.resolution.classList.remove('hidden');
    this.resolutionTitle.textContent = data.summary || 'Pick one option.';
    this.resolutionOptions.innerHTML = '';
    this.pendingResolution = {
      resolution_key: data.resolution_key,
      candidates: Array.isArray(data.candidates) ? data.candidates : [],
    };

    if ((data.candidates || []).length === 1) {
      const hint = document.createElement('p');
      hint.className = 'mb-2 text-xs text-gray-400';
      hint.textContent = getConfirmHint();
      this.resolutionOptions.appendChild(hint);
    }

    (data.candidates || []).forEach((candidate) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = (data.candidates || []).length === 1
        ? 'kay-option-button flex w-full items-center gap-2 rounded-xl border border-[#2563EB]/20 bg-[#EFF4FF] px-3.5 py-2.5 text-sm text-[#1D4ED8] transition-colors hover:bg-[#E8F0FF]'
        : 'kay-option-button flex items-center gap-2 rounded-xl bg-black/[0.04] px-3.5 py-2 text-sm text-gray-700 transition-colors hover:bg-black/[0.07]';
      button.dataset.kayNavItem = 'true';

      const text = document.createElement('span');
      text.textContent = (data.candidates || []).length === 1 ? `Use ${candidate.label}` : candidate.label;

      if (candidate.logo_url) {
        const logo = document.createElement('img');
        logo.src = candidate.logo_url;
        logo.alt = candidate.label || '';
        logo.className = 'kay-program-logo h-5 w-5 shrink-0';
        logo.addEventListener('error', () => {
          const fallbackText = (candidate.label || '')
            .split(/\s+/)
            .filter(Boolean)
            .slice(0, 2)
            .map((part) => part[0])
            .join('')
            .toUpperCase();
          logo.remove();
          if (fallbackText) {
            const fallback = document.createElement('span');
            fallback.className = 'kay-program-fallback h-5 w-5 shrink-0';
            fallback.textContent = fallbackText;
            button.insertBefore(fallback, text);
          }
        }, { once: true });
        button.appendChild(logo);
      }

      button.appendChild(text);
      button.addEventListener('click', () => {
        if (candidate.command) {
          this.fillAndFocus(candidate.command);
          return;
        }
        this.submit({ [data.resolution_key]: candidate.id });
      });
      this.resolutionOptions.appendChild(button);
    });
    this.captureSuggestionItems();
  }

  refreshProgramsTable() {
    const programsTable = document.getElementById('programs-table');
    if (!programsTable || typeof window.htmx?.ajax !== 'function') return;
    window.htmx.ajax('GET', '/programs/get-user-programs/', {
      target: '#programs-table',
      swap: 'innerHTML',
    });
  }
}

let powerMenuController = null;

export function setupPowerMenu() {
  if (!powerMenuController) {
    powerMenuController = new PowerMenuController();
  }
  return powerMenuController;
}
